package com.raouf.mehrguard.web.i18n

internal val HindiStrings = mapOf(
    WebStringKey.AppName to "Mehr Guard",
    WebStringKey.AppTagline to "कोटलिन मल्टीप्लेटफॉर्म QRishing डिटेक्टर",
    WebStringKey.MenuMain to "मुख्य मेनू",
    WebStringKey.MenuSecurity to "सुरक्षा",
    WebStringKey.MenuSystem to "सिस्टम",
    WebStringKey.NavDashboard to "डैशबोर्ड",
    WebStringKey.NavScanMonitor to "स्कैन मॉनिटर",
    WebStringKey.NavScanHistory to "स्कैन इतिहास",
    WebStringKey.NavTrustCentre to "विश्वास केंद्र",
    WebStringKey.NavReports to "रिपोर्ट",
    WebStringKey.NavTraining to "प्रशिक्षण",
    WebStringKey.NavSettings to "सेटिंग्स",
    WebStringKey.QuickActions to "त्वरित कार्रवाई",

    // Hero Section
    WebStringKey.HeroTagline to "सुरक्षित. ऑफ़लाइन.",
    WebStringKey.HeroTagline2 to "व्याख्यायोग्य बचाव.",
    WebStringKey.HeroDescription to "Mehr Guard आपके हार्डवेयर पर सीधे संभावित खतरों का विश्लेषण करता है। शून्य-विलंबता सुरक्षा का अनुभव करें।",

    // Dashboard
    WebStringKey.StartScan to "नया स्कैन शुरू करें",
    WebStringKey.ImportImage to "छवि आयात करें",
    WebStringKey.ScanQrCode to "स्कैन QR कोड",
    WebStringKey.SystemHealth to "सिस्टम स्वास्थ्य",
    WebStringKey.ThreatDatabase to "खतरा डेटाबेस",
    WebStringKey.Current to "वर्तमान",
    WebStringKey.Active to "सक्रिय",
    WebStringKey.Threats to "खतरे",
    WebStringKey.SafeScans to "सुरक्षित स्कैन",
    WebStringKey.EngineActive to "इंजन सक्रिय",
    WebStringKey.EnterpriseProtection to "एंटरप्राइज़ सुरक्षा सक्रिय",
    WebStringKey.SystemOptimal to "सिस्टम इष्टतम",
    WebStringKey.EngineStatus to "इंजन v2.4 • 2 घंटे पहले अपडेट हुआ",
    WebStringKey.ThreatsBlocked to "खतरे अवरुद्ध",
    WebStringKey.AllSystemsOperational to "सभी सिस्टम चालू",

    // Dashboard Sections
    WebStringKey.SectionOverview to "अवलोकन",
    WebStringKey.SectionSecurity to "सुरक्षा",
    WebStringKey.SectionTraining to "प्रशिक्षण",
    WebStringKey.SectionReports to "रिपोर्ट",
    WebStringKey.OfflineReady to "ऑफ़लाइन तैयार",
    WebStringKey.OfflineDescription to "स्थानीय डेटाबेस v2.4.1 सक्रिय। कोई डेटा इस डिवाइस को नहीं छोड़ता है।",

    // Trust Centre
    WebStringKey.TrustCentreTitle to "विश्वास केंद्र",
    WebStringKey.OfflineGuarantee to "सख्त ऑफ़लाइन गारंटी",
    WebStringKey.OfflineGuaranteeDesc to "Mehr Guard विश्लेषण पूरी तरह से आपके डिवाइस के न्यूरल इंजन पर चलता है। URL डेटा कभी भी आपके फोन को नहीं छोड़ता है।",
    WebStringKey.ThreatSensitivity to "खतरे की संवेदनशीलता",
    WebStringKey.ResetConfirm to "यह कार्रवाई सभी विश्वास केंद्र सेटिंग्स को डिफ़ॉल्ट पर रीसेट कर देगी।",

    // Settings Quick Actions
    WebStringKey.ThreatMonitor to "खतरा मॉनिटर",
    WebStringKey.ThreatMonitorDesc to "लाइव खतरे देखें और सुरक्षा जांच चलाएं।",
    WebStringKey.TrustCentreDesc to "गोपनीयता और खतरा संवेदनशीलता सेटिंग्स।",
    WebStringKey.ExportReport to "रिपोर्ट निर्यात करें",
    WebStringKey.ExportReportDesc to "PDF या JSON सुरक्षा रिपोर्ट उत्पन्न करें।",

    // Dashboard Content
    WebStringKey.Analyze to "विश्लेषण",
    WebStringKey.HeuristicEngine to "ह्यूरिस्टिक इंजन",
    WebStringKey.HighPerformanceEngine to "उच्च-प्रदर्शन इंजन",
    WebStringKey.RecentScans to "हाल के स्कैन",
    WebStringKey.ViewFullHistory to "पूर्ण इतिहास देखें",
    WebStringKey.Status to "स्थिति",
    WebStringKey.Source to "स्रोत",
    WebStringKey.Details to "विवरण",
    WebStringKey.Time to "समय",
    WebStringKey.Version to "संस्करण",
    WebStringKey.LastUpdate to "अंतिम अद्यतन",
    WebStringKey.Signatures to "हस्ताक्षर",
    WebStringKey.CheckForUpdates to "अद्यतन के लिए जाँच करें",
    WebStringKey.FeatureOfflineTitle to "ऑफ़लाइन-फर्स्ट आर्किटेक्चर",
    WebStringKey.FeatureOfflineDesc to "पूर्ण विश्लेषण स्थानीय रूप से किया जाता है। आपकी कैमरा फ़ीड और स्कैन किया गया डेटा कभी भी किसी बाहरी सर्वर को नहीं छूता, जो पूर्ण गोपनीयता सुनिश्चित करता है।",
    WebStringKey.FeatureExplainableTitle to "व्याख्यायोग्य सुरक्षा",
    WebStringKey.FeatureExplainableDesc to "सिर्फ़ 'ब्लॉक' न करें। हम URL मापदंडों, रीडायरेक्ट और जावास्क्रिप्ट पेलोड का विस्तृत ह्यूरिस्टिक विवरण प्रदान करते हैं।",
    WebStringKey.FeaturePerformanceDesc to "डेस्कटॉप वातावरण के लिए अनुकूलित। स्कैन को देशी कोटलिन मल्टीप्लेटफ़ॉर्म बायनेरिज़ का उपयोग करके 5ms से कम समय में संसाधित किया जाता है।",
    WebStringKey.TrainingCentre to "प्रशिक्षण केंद्र",
    WebStringKey.LearnHomograph to "उन्नत QR होमोग्राफ हमलों की पहचान करना सीखें।",
    WebStringKey.BeatTheBotAction to "बोट को हराएं →",
    WebStringKey.NoScansYet to "अभी तक कोई स्कैन नहीं। परिणाम देखने के लिए एक नया स्कैन शुरू करें।",
    WebStringKey.VerdictSafe to "सुरक्षित",
    WebStringKey.VerdictPhish to "फ़िशिंग",
    WebStringKey.VerdictWarn to "चेतावनी",
    WebStringKey.ScoreLabel to "स्कोर:",

    // Scanner
    WebStringKey.ActiveScanner to "सक्रिय स्कैनर",
    WebStringKey.OfflineMode to "ऑफफ़लाइन मोड",
    WebStringKey.LiveFeedDisconnected to "लाइव फ़ीड डिस्कनेक्ट",
    WebStringKey.CameraAccessRequired to "कैमरा एक्सेस आवश्यक",
    WebStringKey.CameraAccessDescription to "स्कैनिंग शुरू करने के लिए यहां एक क्यूआर कोड छवि खींचें और छोड़ें या कैमरा एक्सेस सक्षम करें।",
    WebStringKey.EnableCamera to "कैमरा सक्षम करें",
    WebStringKey.Scanning to "स्कैनिंग...",
    WebStringKey.ScanHint to "स्थिर रखें। <5ms में ऑफ़लाइन विश्लेषण।",
    WebStringKey.Torch to "टॉर्च",
    WebStringKey.Gallery to "गैलरी",
    WebStringKey.PasteUrl to "URL पेस्ट करें",
    WebStringKey.PasteUrlTitle to "विश्लेषण के लिए URL पेस्ट करें",
    WebStringKey.AnalyzeUrl to "URL का विश्लेषण करें",
    WebStringKey.SystemStatus to "सिस्टम स्थिति",
    WebStringKey.PhishingEngine to "फ़िशिंग इंजन",
    WebStringKey.Ready to "तैयार",
    WebStringKey.LocalDb to "स्थानीय DB",
    WebStringKey.Latency to "विलंबता",
    WebStringKey.ViewAll to "सभी देखें",

    // Threat / Results
    WebStringKey.BreadcrumbHome to "होम",
    WebStringKey.BreadcrumbScans to "स्कैन",
    WebStringKey.OfflineProtection to "ऑफ़लाइन सुरक्षा",
    WebStringKey.VerdictHighRisk to "उच्च जोखिम का पता चला",
    WebStringKey.VerdictDangerous to "खतरनाक",
    WebStringKey.VerdictDangerousDesc to "स्कैन किए गए QR कोड में फ़िशिंग और क्रेडेंशियल चोरी से जुड़े दुर्भावनापूर्ण संकेतक हैं। लक्ष्य URL पर आगे न बढ़ें。",
    WebStringKey.ThreatConfidence to "खतरा विश्वास",
    WebStringKey.FlagPhishing to "फ़िशिंग प्रयास",
    WebStringKey.FlagObfuscated to "अस्पष्ट स्क्रिप्ट",
    WebStringKey.FlagHomograph to "होमोग्राफ़ हमला",
    WebStringKey.ClearHistory to "सब साफ़ करें",
    WebStringKey.SectionAttackBreakdown to "हमला विवरण",
    WebStringKey.AttackHomographTitle to "होमोग्राफ़ / IDN हमला",
    WebStringKey.AttackHomographDesc to "लैटिन वर्णमाला की नकल करने वाले सिरिलिक वर्णों का पता चला।",
    WebStringKey.AttackVisualLabel to "दृश्य उपस्थिति",
    WebStringKey.AttackPunycodeLabel to "वास्तविक Punycode",
    WebStringKey.AttackHomographExplain to "डोमेन लैटिन 'a' (U+0061) के बजाय सिरिलिक 'а' (U+0430) का उपयोग करता है। इस तकनीक का उपयोग आमतौर पर उपयोगकर्ताओं को यह विश्वास दिलाने के लिए किया जाता है कि वे एक वैध सेवा पर जा रहे हैं।",
    WebStringKey.AttackRedirectTitle to "संदिग्ध पुनर्निर्देशन श्रृंखला",
    WebStringKey.AttackRedirectDesc to "ज्ञात URL शॉर्टनर्स वाले 3 हॉप्स का पता चला।",
    WebStringKey.RedirectStart to "QR कोड स्कैन",
    WebStringKey.RedirectHop to "इंटरमीडिएट हॉप",
    WebStringKey.RedirectFinal to "अंतिम गंतव्य",
    WebStringKey.AttackJsTitle to "अस्पष्ट जावास्क्रिप्ट",
    WebStringKey.AttackJsDesc to "URL मापदंडों में उच्च एन्ट्रापी स्ट्रिंग का पता चला।",
    WebStringKey.SectionActions to "अनुशंसित कार्रवाई",
    WebStringKey.ActionBlock to "ब्लॉक और रिपोर्ट करें",
    WebStringKey.ActionBlockDesc to "पहुंच रोकें और व्यवस्थापकों को सूचित करें।",
    WebStringKey.ActionQuarantine to "सैंडबॉक्स में क्वारंटाइन करें",
    WebStringKey.ActionQuarantineDesc to "विश्लेषण के लिए सुरक्षित रूप से खोलें।",
    WebStringKey.Expected to "अपेक्षित: ",
    WebStringKey.Detected to "पता चला: ",
    WebStringKey.ExplainableSecurity to "व्याख्यायोग्य सुरक्षा",
    WebStringKey.UrlBreakdown to "URL विश्लेषण",
    WebStringKey.FullUrl to "पूर्ण URL",
    WebStringKey.OpenInBrowser to "ब्राउज़र में खोलें (जोखिम)",
    WebStringKey.OpenWarning to "इस URL को ब्राउज़र में खोलने से आप सुरक्षा जोखिमों के संपर्क में आ सकते हैं।",
    WebStringKey.RestrictedMode to "प्रतिबंधित मोड",
    WebStringKey.RestrictedDesc to "यह URL संभावित रूप से हानिकारक के रूप में चिह्नित है। आगे बढ़ने से पहले नीचे विश्लेषण की समीक्षा करें।",
    WebStringKey.DangerousWarning to "यह URL संभावित रूप से हानिकारक के रूप में चिह्नित है। इसे खोलने से आप फ़िशिंग, मैलवेयर, या अन्य सुरक्षा खतरों के संपर्क में आ सकते हैं। क्या आप सुनिश्चित हैं कि आप जारी रखना चाहते हैं?",
    WebStringKey.CopyUrl to "URL कॉपी करें",
    WebStringKey.Share to "शेयर",
    WebStringKey.Dismiss to "खारिज करें",
    WebStringKey.ReasonDomainAge to "डोमेन की आयु 24 घंटे से कम है।",
    WebStringKey.ReasonSignatures to "स्थानीय फ़िशिंग DB में 3 हस्ताक्षरों से मेल खाया।",
    WebStringKey.ReasonAsn to "लक्ष्य IP उच्च जोखिम वाले ASN में स्थित है।",
    WebStringKey.SectionMeta to "स्कैन मेटाडेटा",
    WebStringKey.MetaTime to "स्कैन का समय",
    WebStringKey.MetaSource to "स्रोत",
    WebStringKey.MetaEngine to "इंजन",
    WebStringKey.MetaOfflineGuaranteeLabel to "ऑफ़लाइन गारंटी:",
    WebStringKey.MetaOfflineGuaranteeDesc to "इस छवि का विश्लेषण आपके डिवाइस पर स्थानीय रूप से किया गया था। इस निर्णय के लिए क्लाउड पर कोई डेटा नहीं भेजा गया।",
    
    // Results Page
    WebStringKey.ScanComplete to "स्कैन पूर्ण",
    WebStringKey.Loading to "लोड हो रहा है...",
    WebStringKey.AnalyzedOffline to "<5ms में ऑफ़लाइन विश्लेषित",
    WebStringKey.NoDataLeaves to "डेटा डिवाइस से बाहर नहीं जाता",
    WebStringKey.ActiveProtection to "सक्रिय सुरक्षा",
    WebStringKey.ConfidenceScore to "विश्वास स्कोर",
    WebStringKey.Analyzing to "विश्लेषण हो रहा है...",
    WebStringKey.ProcessingResults to "स्कैन परिणाम संसाधित हो रहे हैं...",
    WebStringKey.RiskAssessment to "जोखिम मूल्यांकन",
    WebStringKey.AnalysisTime to "विश्लेषण समय",
    WebStringKey.Heuristics to "ह्यूरिस्टिक्स",
    WebStringKey.TopAnalysisFactors to "शीर्ष विश्लेषण कारक",
    WebStringKey.Pass to "पास",
    WebStringKey.Info to "जानकारी",
    WebStringKey.Clean to "स्वच्छ",
    WebStringKey.ValidSslCertificate to "मान्य SSL प्रमाणपत्र",
    WebStringKey.SslCertificateDesc to "DigiCert Inc द्वारा जारी प्रमाणपत्र। विश्वास श्रृंखला में कोई विसंगति नहीं।",
    WebStringKey.EstablishedDomain to "स्थापित डोमेन",
    WebStringKey.EstablishedDomainDesc to "डोमेन 5 वर्ष से अधिक पहले पंजीकृत। धोखाधड़ी की कम संभावना।",
    WebStringKey.BlacklistStatus to "ब्लैकलिस्ट स्थिति",
    WebStringKey.BlacklistStatusDesc to "52 स्थानीय खतरा डेटाबेस में नहीं पाया गया।",
    WebStringKey.BackToDashboard to "डैशबोर्ड पर वापस",
    WebStringKey.ShareReport to "रिपोर्ट साझा करें",
    WebStringKey.CopyLink to "लिंक कॉपी करें",
    WebStringKey.LinkCopied to "लिंक क्लिपबोर्ड पर कॉपी हुई!",
    
    // Game Page
    WebStringKey.BeatTheBot to "बॉट को हराओ",
    WebStringKey.BeatTheBotDesc to "हमारे ऑफ़लाइन AI को चुनौती दें। क्या आप फ़िशिंग तेज़ी से पहचान सकते हैं?",
    WebStringKey.SessionId to "सत्र ID",
    WebStringKey.EndSession to "सत्र समाप्त करें",
    WebStringKey.Round to "राउंड",
    WebStringKey.BrowserPreview to "ब्राउज़र पूर्वावलोकन",
    WebStringKey.MakeDecision to "अपना निर्णय लें",
    WebStringKey.Phishing to "फ़िशिंग",
    WebStringKey.Legitimate to "वैध",
    WebStringKey.LiveHint to "लाइव संकेत",
    WebStringKey.LiveScoreboard to "लाइव स्कोरबोर्ड",
    WebStringKey.VsMode to "VS मोड",
    WebStringKey.You to "आप",
    WebStringKey.Points to "अंक",
    WebStringKey.Streak to "स्ट्रीक",
    WebStringKey.Accuracy to "सटीकता",
    WebStringKey.MehrGuardBot to "Mehr Guard बॉट",
    WebStringKey.Confidence to "विश्वास",
    WebStringKey.RoundAnalysis to "राउंड विश्लेषण",
    WebStringKey.Analysis to "विश्लेषण",
    WebStringKey.CorrectDecision to "सही निर्णय!",
    WebStringKey.IdentifiedSafe to "आपने सुरक्षित URL को सही पहचाना।",
    WebStringKey.AiNeuralAnalysis to "AI न्यूरल विश्लेषण",
    WebStringKey.WhyBotFlagged to "बॉट ने क्यों फ़्लैग किया",
    WebStringKey.EducationalNote to "शैक्षिक नोट",
    WebStringKey.Correct to "सही!",
    WebStringKey.SpottedPhishing to "आपने फ़िशिंग URL को सही पहचाना।",
    WebStringKey.Response to "प्रतिक्रिया",
    WebStringKey.NextRound to "अगला राउंड",
    WebStringKey.GameOver to "खेल समाप्त!",
    WebStringKey.FinalResults to "अंतिम परिणाम",
    WebStringKey.YourScore to "आपका स्कोर",
    WebStringKey.BotScore to "बॉट स्कोर",
    WebStringKey.BestStreak to "सर्वश्रेष्ठ स्ट्रीक",
    WebStringKey.PlayAgain to "फिर से खेलें",
    WebStringKey.ReturnToDashboard to "डैशबोर्ड पर लौटें",
    
    // Export Page
    WebStringKey.ExportSecurityReport to "सुरक्षा रिपोर्ट निर्यात करें",
    WebStringKey.GenerateReport to "स्कैन इतिहास से पूर्ण सुरक्षा रिपोर्ट बनाएं।",
    WebStringKey.ReportFormat to "रिपोर्ट प्रारूप",
    WebStringKey.HumanReadable to "मानव-पठनीय रिपोर्ट",
    WebStringKey.HumanReadableDesc to "दृश्य विश्लेषण और सारांश के साथ PDF",
    WebStringKey.MachineReadable to "मशीन-पठनीय डेटा",
    WebStringKey.MachineReadableDesc to "SIEM एकीकरण के लिए JSON प्रारूप",
    WebStringKey.DateRange to "तिथि सीमा",
    WebStringKey.Last7Days to "पिछले 7 दिन",
    WebStringKey.Last30Days to "पिछले 30 दिन",
    WebStringKey.Last90Days to "पिछले 90 दिन",
    WebStringKey.AllTime to "सभी समय",
    WebStringKey.CustomRange to "कस्टम सीमा",
    WebStringKey.ReportSections to "रिपोर्ट अनुभाग",
    WebStringKey.ExecutiveSummary to "कार्यकारी सारांश",
    WebStringKey.ThreatBreakdown to "खतरा विश्लेषण",
    WebStringKey.ScanTimeline to "स्कैन टाइमलाइन",
    WebStringKey.SafeUrlList to "सुरक्षित URL सूची",
    WebStringKey.GenerateExport to "रिपोर्ट निर्यात करें",
    
    // Toast / Notifications
    WebStringKey.Success to "सफलता!",
    WebStringKey.Error to "त्रुटि",
    WebStringKey.Warning to "चेतावनी",
    WebStringKey.CopiedToClipboard to "क्लिपबोर्ड पर कॉपी किया गया",
    
    // General Actions
    WebStringKey.Cancel to "रद्द करें",
    WebStringKey.Confirm to "पुष्टि करें",
    WebStringKey.Save to "सहेजें",
    WebStringKey.Delete to "हटाएं",
    WebStringKey.Edit to "संपादित करें",
    WebStringKey.Close to "बंद करें",
    WebStringKey.Back to "वापस",
    WebStringKey.Next to "आगे",
    WebStringKey.Previous to "पिछला",
    WebStringKey.Submit to "सबमिट करें",
    WebStringKey.Reset to "रीसेट",
    WebStringKey.Clear to "साफ़ करें",
    WebStringKey.Search to "खोजें",
    WebStringKey.Filter to "फ़िल्टर",
    WebStringKey.Sort to "क्रमबद्ध करें",
    
    // Accessibility
    WebStringKey.ToggleMenu to "मेनू टॉगल करें",
    WebStringKey.ToggleTheme to "थीम टॉगल करें",
    WebStringKey.Notifications to "सूचनाएं",
    WebStringKey.Help to "सहायता",
    WebStringKey.Profile to "प्रोफ़ाइल",
    WebStringKey.ToggleLightDarkMode to "लाइट/डार्क मोड टॉगल करें",
    
    // Placeholders
    WebStringKey.UrlInputPlaceholder to "विश्लेषण के लिए URL पेस्ट करें (उदा.: https://example.com)",
    WebStringKey.UrlExamplePlaceholder to "https://example.com",
    
    // Export Page Additional
    WebStringKey.Scan to "स्कैन",
    WebStringKey.Result to "परिणाम",
    WebStringKey.ReportGeneration to "रिपोर्ट जनरेशन",
    WebStringKey.ReportGenerationDesc to "प्रारूप कॉन्फ़िगर करें और खतरा विश्लेषण डाउनलोड करें।",
    WebStringKey.OfflineSecurity to "ऑफ़लाइन सुरक्षा",
    WebStringKey.OfflineSecurityDesc to "आपका डेटा कभी इस डिवाइस से बाहर नहीं जाता। सभी प्रोसेसिंग स्थानीय है।",
    WebStringKey.ChooseFormat to "प्रारूप चुनें",
    WebStringKey.PdfFormatDesc to "PDF प्रारूप। साझा करने के लिए उत्तम।",
    WebStringKey.JsonFormatDesc to "JSON प्रारूप। SIEM एकीकरण के लिए उत्तम।",
    WebStringKey.Copy to "कॉपी",
    WebStringKey.LivePreview to "लाइव प्रीव्यू",
    WebStringKey.ReadOnly to "केवल पठन",
    WebStringKey.ThreatAnalysisReport to "खतरा विश्लेषण रिपोर्ट",
    WebStringKey.Verdict to "निर्णय",
    WebStringKey.RiskScore to "जोखिम स्कोर",
    WebStringKey.TargetUrl to "लक्ष्य URL",
    WebStringKey.AnalysisSummaryLabel to "विश्लेषण सारांश",
    WebStringKey.TechnicalIndicators to "तकनीकी संकेतक",
    WebStringKey.ExportInfoNote to "निर्यात में सभी पहचाने गए खतरा वेक्टर और पेलोड विश्लेषण शामिल हैं।",
    
    // Trust Centre Page
    WebStringKey.AllowList to "अनुमति सूची",
    WebStringKey.BlockList to "ब्लॉक सूची",
    WebStringKey.AddDomain to "डोमेन जोड़ें",
    WebStringKey.RemoveDomain to "डोमेन हटाएं",
    WebStringKey.TrustedDomains to "विश्वसनीय डोमेन",
    WebStringKey.BlockedDomains to "अवरुद्ध डोमेन",
    WebStringKey.DomainPlaceholder to "डोमेन दर्ज करें (उदा.: example.com)",
    
    // Game Page Additional
    WebStringKey.Safe to "सुरक्षित",
    WebStringKey.TimeAgo to "पहले",
    WebStringKey.MinutesAgo to "मिनट पहले",
    WebStringKey.HoursAgo to "घंटे पहले",
    
    // Misc
    WebStringKey.Critical to "गंभीर",
    WebStringKey.Warn to "चेतावनी",
    
    // Trust Centre - Sensitivity
    WebStringKey.PhishingDetectionSensitivity to "फ़िशिंग पहचान संवेदनशीलता",
    WebStringKey.SensitivityDescription to "ह्यूरिस्टिक थ्रेशोल्ड समायोजित करें। उच्च संवेदनशीलता झूठी सकारात्मकता बढ़ा सकती है।",
    WebStringKey.SensitivityLow to "निम्न",
    WebStringKey.SensitivityBalanced to "संतुलित",
    WebStringKey.SensitivityParanoia to "पैरानोइया",
    WebStringKey.BalancedModeRecommended to "संतुलित मोड (अनुशंसित)",
    WebStringKey.BalancedModeDesc to "ज्ञात दुर्भावनापूर्ण पैटर्न और ह्यूरिस्टिक बेमेल के लिए स्कैन करता है। होमोग्लिफ़ हमलों और रीडायरेक्ट चेन को ब्लॉक करता है।",
    WebStringKey.LowSensitivityMode to "कम संवेदनशीलता मोड",
    WebStringKey.LowSensitivityModeDesc to "केवल खतरे के डेटाबेस से ज्ञात दुर्भावनापूर्ण URLs को ब्लॉक करता है। न्यूनतम झूठी सकारात्मक, लेकिन नए हमलों को छोड़ सकता है।",
    WebStringKey.ParanoiaMode to "पैरानोइया मोड",
    WebStringKey.ParanoiaModeDesc to "अधिकतम सुरक्षा। नए पंजीकृत डोमेन, असामान्य TLDs और संभावित एन्कोडिंग ट्रिक्स वाले किसी भी संदिग्ध पैटर्न को ब्लॉक करता है।",
    WebStringKey.PrivacyGuaranteeDesc to "Mehr Guard स्थानीय ह्यूरिस्टिक विश्लेषण इंजन का उपयोग करता है। स्कैनिंग के दौरान कोई छवि डेटा, URL स्ट्रिंग या मेटाडेटा इस डिवाइस को नहीं छोड़ता। आपकी गोपनीयता गणितीय रूप से गारंटीकृत है।",
    WebStringKey.SignalBrandImpersonation to "संभावित ब्रांड प्रतिरूपण का पता चला",
    WebStringKey.SignalCredentialParams to "URL में क्रेडेंशियल-संबंधित पैरामीटर",
    WebStringKey.SignalEncodedPayload to "क्वेरी पैरामीटर में एन्कोडेड डेटा का पता चला",
    WebStringKey.SignalExcessiveSubdomains to "अत्यधिक सबडोमेन गहराई ({count} स्तर)",
    WebStringKey.SignalHighEntropyHost to "डोमेन नाम में उच्च यादृच्छिकता",
    WebStringKey.SignalHomographAttack to "डोमेन में होमोग्राफ/भ्रमित करने वाले वर्ण हैं",
    WebStringKey.SignalHttpNotHttps to "असुरक्षित HTTP प्रोटोकॉल का उपयोग करता है",
    WebStringKey.SignalIpAddressHost to "होस्ट डोमेन के बजाय IP पता है",
    WebStringKey.SignalLongUrl to "असामान्य रूप से लंबा URL ({length} वर्ण)",
    WebStringKey.SignalLongUrlMarketing to "असामान्य रूप से लंबा URL ({length} वर्ण) - मार्केटिंग पैरामीटर शामिल हैं",
    WebStringKey.SignalNewlyRegisteredDomain to "नया पंजीकृत डोमेन पाया गया",
    WebStringKey.SignalNonStandardPort to "गैर-मानक पोर्ट: {port}",
    WebStringKey.SignalNumericSubdomain to "केवल संख्यात्मक सबडोमेन का पता चला",
    WebStringKey.SignalSuspiciousPathKeywords to "पथ में संदिग्ध कीवर्ड ({count} पाए गए)",
    WebStringKey.SignalSuspiciousTld to "संदिग्ध TLD: {tld}",
    WebStringKey.SignalUrlShortener to "URL छोटा करने वाली सेवा का उपयोग करता है",
    WebStringKey.SecureEnvironment to "सुरक्षित वातावरण",
    WebStringKey.LearnLocalArchitecture to "हमारी स्थानीय वास्तुकला के बारे में जानें",
    WebStringKey.NoCustomDomainsBlocked to "कोई कस्टम डोमेन ब्लॉक नहीं।",
    WebStringKey.AddManually to "मैन्युअल रूप से जोड़ें",
    WebStringKey.AddedDaysAgo to "2 दिन पहले जोड़ा गया",
    WebStringKey.AddedWeekAgo to "1 सप्ताह पहले जोड़ा गया",
    
    // Trust Centre - Privacy Controls
    WebStringKey.PrivacyControls to "गोपनीयता नियंत्रण",
    WebStringKey.StrictOfflineMode to "सख्त ऑफ़लाइन मोड",
    WebStringKey.DisableExternalPreviews to "सभी बाहरी लिंक पूर्वावलोकन अक्षम करें।",
    WebStringKey.AnonymousTelemetry to "अनाम टेलीमेट्री",
    WebStringKey.ShareDetectionStats to "ML सुधारने के लिए पहचान आँकड़े साझा करें।",
    WebStringKey.AutoCopySafeLinks to "सुरक्षित लिंक ऑटो-कॉपी",
    WebStringKey.CopyTrustedUrls to "विश्वसनीय URL क्लिपबोर्ड पर कॉपी करें।",
    
    // Trust Centre - About
    WebStringKey.AboutMehrGuard to "Mehr Guard के बारे में",
    WebStringKey.OpenSourceLicenses to "ओपन सोर्स लाइसेंस",
    WebStringKey.PrivacyPolicy to "गोपनीयता नीति",
    WebStringKey.Acknowledgements to "आभार",
    WebStringKey.ResetAllSettings to "सभी सेटिंग्स रीसेट करें",
    WebStringKey.AddToAllowlist to "अनुमति सूची में जोड़ें",
    WebStringKey.AddToBlocklist to "ब्लॉक सूची में जोड़ें",
    
    // Onboarding
    WebStringKey.AnalysedOfflineTitle to "ऑफ़लाइन विश्लेषित।",
    WebStringKey.YourDataStaysOnDevice to "आपका डेटा डिवाइस पर रहता है।",
    WebStringKey.OnboardingHeroDesc to "Mehr Guard हर स्कैन को सुरक्षित ऑन-डिवाइस विश्लेषण के साथ संसाधित करता है। हम शून्य क्लाउड टेलीमेट्री के साथ व्याख्यात्मक सुरक्षा को प्राथमिकता देते हैं।",
    WebStringKey.OnDeviceAnalysis to "ऑन-डिवाइस विश्लेषण",
    WebStringKey.OnDeviceAnalysisDesc to "सभी खतरा पहचान आपके डिवाइस पर स्थानीय रूप से चलती है। कोई डेटा आपके सिस्टम से बाहर नहीं जाता।",
    WebStringKey.NoCloudLogs to "कोई क्लाउड लॉग नहीं",
    WebStringKey.NoCloudLogsDesc to "हम स्कैन के लिए आउटगोइंग टेलीमेट्री को सख्ती से अक्षम करते हैं। परिणाम और हैश स्थानीय रहते हैं।",
    WebStringKey.OnDeviceDB to "ऑन-डिवाइस डेटाबेस",
    WebStringKey.OnDeviceDBDesc to "मिलीसेकंड लुकअप के लिए पूर्ण खतरा हस्ताक्षर डेटाबेस आपके डिवाइस पर डाउनलोड होता है।",
    WebStringKey.DataLifecycleVerification to "डेटा जीवनचक्र सत्यापन",
    WebStringKey.SecurityAuditPass to "सुरक्षा ऑडिट: पास",
    
    // Footer
    WebStringKey.Copyright to "© 2024 Mehr Guard Security Inc. सर्वाधिकार सुरक्षित।",
    WebStringKey.Support to "सहायता",
    WebStringKey.Terms to "शर्तें",
    WebStringKey.SystemsOperational to "सिस्टम चालू",
    WebStringKey.SystemSecure to "सिस्टम सुरक्षित",
    
    // Version / Build Info
    WebStringKey.VersionStatus to "v2.4.1 • सिस्टम सुरक्षित",
    WebStringKey.CoreVersion to "Core v2.4.1 • Build 2024.12.19",
    WebStringKey.VerifiedBy to "Mehr Guard Enterprise द्वारा सत्यापित",
    
    // User Profile (Sample)
    WebStringKey.SampleUserName to "राहुल शर्मा",
    WebStringKey.SampleUserRole to "सुरक्षा विश्लेषक",
    
    // Export Preview
    WebStringKey.DetailLabel to "विवरण लेबल",
    WebStringKey.DetailValue to "विवरण मान",
    WebStringKey.Suspicious to "संदिग्ध",
    
    // Game Modal Strings
    WebStringKey.IncorrectDecision to "गलत निर्णय",
    WebStringKey.WrongAnswer to "उफ़! यह गलत था।",
    WebStringKey.ResponseTime to "प्रतिक्रिया समय",
    WebStringKey.IncomingMessage to "आने वाला संदेश",
    WebStringKey.CertificateIssuer to "प्रमाणपत्र जारीकर्ता डोमेन मालिक से मेल खाता है",
    WebStringKey.DomainAgeTrust to "डोमेन आयु > 5 वर्ष (उच्च विश्वास)",
    WebStringKey.WhitelistedRank to "स्थानीय श्वेतसूची में Alexa शीर्ष 1k",
    
    // Game Tips/Hints
    WebStringKey.GameEducationalNote to "शैक्षिक नोट",
    WebStringKey.GameHintTitle to "गेम संकेत",
    
    // Trust Modal
    WebStringKey.AddToAllowlistTitle to "अनुमति सूची में जोड़ें",
    WebStringKey.AddToBlocklistTitle to "ब्लॉक सूची में जोड़ें",
    WebStringKey.EnterDomainPrompt to "अपनी सूची में जोड़ने के लिए डोमेन दर्ज करें",
    
    // Additional Game Strings
    WebStringKey.LatencyMs to "विलंबता",
    WebStringKey.StreakFire to "स्ट्रीक",
    WebStringKey.AccuracyPercent to "सटीकता",
    WebStringKey.ConfidencePercent to "विश्वास",
    
    // Languages
    WebStringKey.English to "अंग्रेज़ी",
    WebStringKey.German to "जर्मन",
    WebStringKey.Spanish to "स्पेनिश",
    WebStringKey.French to "फ़्रेंच",
    WebStringKey.ChineseSimplified to "चीनी (सरलीकृत)",
    WebStringKey.Japanese to "जापानी",
    WebStringKey.Hindi to "हिंदी",
    WebStringKey.Arabic to "अरबी",
    WebStringKey.Indonesian to "इंडोनेशियाई",
    WebStringKey.Italian to "इतालवी",
    WebStringKey.Korean to "कोरियाई",
    WebStringKey.Portuguese to "पुर्तगाली",
    WebStringKey.Russian to "रूसी",
    WebStringKey.Thai to "थाई",
    WebStringKey.Turkish to "तुर्की",
    WebStringKey.Vietnamese to "वियतनामी"
,
    WebStringKey.ComponentVoting to "घटक मतदान",
    WebStringKey.Heuristic to "अनुमान",
    WebStringKey.MLModel to "एमएल मॉडल",
    WebStringKey.Brand to "ब्रांड",
    WebStringKey.TLD to "टीएलडी",
    WebStringKey.VotingExplanation to "बहुमत मतदान निर्णय निर्धारित करता है: 3+ सुरक्षित = हरा, 2+ दुर्भावनापूर्ण = लाल"
,
    // Results Page Placeholders,
    WebStringKey.WaitingForScan to "स्कैन की प्रतीक्षा में...",
    WebStringKey.WaitingForAnalysis to "विश्लेषण की प्रतीक्षा में...",
    WebStringKey.ScanURLToSeeResults to "विस्तृत परिणाम देखने के लिए URL स्कैन करें।",

    // Keyboard Shortcuts & Settings
    WebStringKey.KeyboardShortcuts to "कीबोर्ड शॉर्टकट",
    WebStringKey.StartScanner to "स्कैनर शुरू करें",
    WebStringKey.CloseMenuModal to "मेन्यू / मोडल बंद करें",
    WebStringKey.NavigateToDashboard to "डैशबोर्ड पर जाएं",
    WebStringKey.NavigateToHistory to "स्कैन इतिहास",
    WebStringKey.NavigateToTrust to "ट्रस्ट सेंटर / अनुमति सूची",
    WebStringKey.NavigateToGame to "बीट द बॉट गेम",
    WebStringKey.ShowHelp to "सहायता दिखाएं",
    WebStringKey.GotIt to "समझ गया",
    WebStringKey.SecuritySettings to "सुरक्षा सेटिंग्स",
    WebStringKey.SensitivityLevel to "संवेदनशीलता स्तर",
    WebStringKey.AutoBlockThreats to "खतरों को स्वचालित रूप से रोकें",
    WebStringKey.RealTimeScanning to "रीयल-टाइम स्कैनिंग",
    WebStringKey.SoundAlerts to "ध्वनि सूचनाएं",
    WebStringKey.ThreatAlerts to "खतरे की सूचनाएं",
    WebStringKey.ShowConfidenceScore to "विश्वास स्कोर दिखाएं",
    WebStringKey.CompactView to "संक्षिप्त दृश्य",
    WebStringKey.ResetDefaults to "डिफ़ॉल्ट रीसेट करें",
    WebStringKey.SaveAndContinue to "सहेजें और जारी रखें",
    
    // Result Screen Verdicts
    WebStringKey.VerdictSuspicious to "संदिग्ध गतिविधि",
    WebStringKey.VerdictWarning to "चेतावनी",
    WebStringKey.VerdictSuspiciousDesc to "स्कैन किया गया QR कोड संदिग्ध पैटर्न दिखाता है जो संभावित सुरक्षा जोखिमों का संकेत दे सकते हैं। सावधानी से आगे बढ़ें।",
    WebStringKey.VerdictMinorConcerns to "मामूली चिंताएं",
    WebStringKey.VerdictCaution to "सावधान",
    WebStringKey.VerdictMinorConcernsDesc to "कुछ मामूली सुरक्षा चिंताएं पहचानी गई। लिंक ज्यादातर सुरक्षित दिखता है लेकिन समीक्षा की सिफारिश की जाती है।",
    WebStringKey.VerdictVerifiedSafe to "सत्यापित सुरक्षित",
    WebStringKey.VerdictSafeLabel to "सुरक्षित",
    WebStringKey.VerdictVerifiedSafeDesc to "कोई सुरक्षा खतरे नहीं मिले। QR कोड सत्यापित सुरक्षित गंतव्य की ओर ले जाता है।",
    WebStringKey.VerdictNoActivity to "कोई गतिविधि नहीं",
    WebStringKey.VerdictAwaitingScan to "स्कैन की प्रतीक्षा",
    WebStringKey.VerdictNoActivityDesc to "कोई स्कैन डेटा उपलब्ध नहीं। कृपया QR कोड स्कैन करें या विश्लेषण के लिए URL दर्ज करें।",
    WebStringKey.ScanQrToSeeActivity to "अपनी गतिविधि देखने के लिए QR कोड स्कैन करें",
    
    // Data Lifecycle Table
    WebStringKey.DataPoint to "डेटा पॉइंट",
    WebStringKey.ProcessingEnv to "प्रसंस्करण वातावरण",
    WebStringKey.ExternalTransmission to "बाह्य प्रसारण",
    WebStringKey.RawImageBuffer to "कच्चा छवि बफर",
    WebStringKey.LocalMemoryRam to "स्थानीय मेमोरी (RAM)",
    WebStringKey.TransmissionNone to "कोई नहीं",
    WebStringKey.DecodedUrlPayload to "डिकोडेड URL/पेलोड",
    WebStringKey.LocalAnalysis to "स्थानीय विश्लेषण",
    WebStringKey.ThreatVerdictLabel to "खतरा निर्णय",
    WebStringKey.LocalDatabase to "स्थानीय डेटाबेस",

    // Missing Keys - Security Signals & Results
    WebStringKey.AboutDescription to "Mehr Guard Security के बारे में",
    WebStringKey.ActualDomain to "वास्तविक डोमेन",
    WebStringKey.AnalysisComplete to "विश्लेषण पूर्ण",
    WebStringKey.AutoBlockThreatsDesc to "खतरों को स्वचालित रूप से ब्लॉक करें",
    WebStringKey.AwaitingScanLabel to "स्कैन की प्रतीक्षा में",
    WebStringKey.BrandImpersonation to "ब्रांड प्रतिरूपण",
    WebStringKey.CautionAdvised to "सावधानी अनुशंसित",
    WebStringKey.CompactViewDesc to "कॉम्पैक्ट व्यू",
    WebStringKey.DoNotVisit to "न जाएं",
    WebStringKey.DoNotVisitDesc to "उच्च विश्वसनीयता वाली फ़िशिंग का पता चला। यह URL कई दुर्भावनापूर्ण संकेतक दिखाता है।",
    WebStringKey.DomainUsesInternationalChars to "यह डोमेन अंतर्राष्ट्रीय वर्णों का उपयोग करता है जो वैध डोमेन की नकल कर सकते हैं।",
    WebStringKey.GoToScanner to "स्कैनर पर जाएं",
    WebStringKey.Hebrew to "हिब्रू",
    WebStringKey.HelpKeyboardShortcuts to "कीबोर्ड शॉर्टकट",
    WebStringKey.HeuristicAnalysis to "हेयुरिस्टिक विश्लेषण",
    WebStringKey.HeuristicAnalysisDesc to "URL को विश्लेषण इंजन द्वारा पता लगाए गए कई जोखिम कारकों के आधार पर चिह्नित किया गया।",
    WebStringKey.HiddenDestination to "छिपा हुआ गंतव्य",
    WebStringKey.HighRisk to "उच्च जोखिम",
    WebStringKey.HighRiskLabel to "उच्च जोखिम",
    WebStringKey.HomographIdnAttack to "होमोग्राफ / IDN अटैक",
    WebStringKey.InternationalizedDomainDetected to "अंतर्राष्ट्रीय डोमेन नाम का पता चला।",
    WebStringKey.JustNow to "अभी",
    WebStringKey.KeyboardShortcutsDesc to "त्वरित पहुंच के लिए कीबोर्ड शॉर्टकट",
    WebStringKey.LiveFeedActive to "लाइव फ़ीड सक्रिय",
    WebStringKey.LowRisk to "कम जोखिम",
    WebStringKey.LowRiskLabel to "कम जोखिम",
    WebStringKey.Malicious to "दुर्भावनापूर्ण",
    WebStringKey.MediumRiskLabel to "मध्यम जोखिम",
    WebStringKey.NoData to "कोई डेटा नहीं",
    WebStringKey.NoScanDataResults to "कोई स्कैन डेटा उपलब्ध नहीं। विश्लेषण परिणाम देखने के लिए URL स्कैन करें।",
    WebStringKey.NoUrlScanned to "कोई URL स्कैन नहीं हुआ",
    WebStringKey.Persian to "फ़ारसी",
    WebStringKey.PhishingIndicators to "फ़िशिंग संकेतक",
    WebStringKey.ProceedWithCaution to "सावधानी से आगे बढ़ें",
    WebStringKey.ProceedWithCautionDesc to "कुछ संदिग्ध संकेतक पाए गए। संवेदनशील जानकारी दर्ज करने से पहले स्रोत की पुष्टि करें।",
    WebStringKey.RealTimeScanningDesc to "रियल-टाइम स्कैनिंग",
    WebStringKey.RedirectShortenerDetected to "रीडायरेक्ट/शॉर्टनर पाया गया",
    WebStringKey.SafeToVisit to "देखने के लिए सुरक्षित",
    WebStringKey.SafeToVisitDesc to "स्थानीय हेयुरिस्टिक v2.4 द्वारा सत्यापित। कोई फ़िशिंग पैटर्न, अस्पष्ट स्क्रिप्ट या ब्लैकलिस्ट मिलान नहीं मिला।",
    WebStringKey.SafetyScore to "सुरक्षा स्कोर",
    WebStringKey.ScanCompleteLabel to "स्कैन पूर्ण",
    WebStringKey.ScanToAnalyze to "विश्लेषण के लिए QR कोड स्कैन करें या URL दर्ज करें।",
    WebStringKey.ScannedURLLabel to "स्कैन किया गया URL",
    WebStringKey.SecuritySignal to "सुरक्षा सिग्नल",
    WebStringKey.SensitivityLevelDesc to "संवेदनशीलता स्तर",
    WebStringKey.SensitivityPermissive to "अनुमोदक",
    WebStringKey.SensitivityStrict to "सख्त",
    WebStringKey.SettingsDetection to "पहचान",
    WebStringKey.SettingsDisplay to "प्रदर्शन",
    WebStringKey.SettingsLanguage to "भाषा",
    WebStringKey.SettingsLanguageDesc to "UI भाषा चुनें",
    WebStringKey.SettingsNotifications to "सूचनाएं",
    WebStringKey.SettingsSavedAutomatically to "सेटिंग्स स्वचालित रूप से सहेजी जाती हैं और सत्रों में सिंक होती हैं।",
    WebStringKey.ShowConfidenceScoreDesc to "विश्वास स्कोर दिखाएं",
    WebStringKey.SoundAlertsDesc to "ध्वनि अलर्ट",
    WebStringKey.SuspiciousDomain to "संदिग्ध डोमेन",
    WebStringKey.SuspiciousEncoding to "संदिग्ध एन्कोडिंग",
    WebStringKey.SuspiciousKeywords to "संदिग्ध कीवर्ड",
    WebStringKey.SuspiciousTld to "संदिग्ध TLD",
    WebStringKey.SuspiciousTldDesc to "डोमेन {tld} TLD का उपयोग करता है जो आमतौर पर दुर्भावनापूर्ण साइटों से जुड़ा होता है।",
    WebStringKey.SuspiciousUrlParams to "संदिग्ध URL पैरामीटर",
    WebStringKey.SuspiciousUrlParamsDesc to "URL में जटिल या संभावित रूप से अस्पष्ट पैरामीटर हैं।",
    WebStringKey.ThreatAlertsDesc to "खतरे की चेतावनी",
    WebStringKey.ThreatDetected to "खतरा पाया गया",
    WebStringKey.UnableToDetermine to "निर्णय निर्धारित करने में असमर्थ। कृपया पुनः प्रयास करें।",
    WebStringKey.Unknown to "अज्ञात",
    WebStringKey.UnknownURL to "अज्ञात URL",
    WebStringKey.UrlShortenerDesc to "URL एक शॉर्टनिंग सेवा का उपयोग करता है जो अंतिम गंतव्य को छुपाता है।",
    WebStringKey.UrlShortenerDetected to "URL शॉर्टनर पाया गया",
    WebStringKey.VersionOfflineReady to "ऑफ़लाइन तैयार",
    WebStringKey.VisualAppearance to "दृश्य स्वरूप",
    WebStringKey.WaitingForAnalysisLabel to "विश्लेषण की प्रतीक्षा में...",

    // Reason Code Titles and Descriptions (for i18n of attack analysis cards)
    // CRITICAL severity
    WebStringKey.ReasonJavascriptUrlTitle to "JavaScript URL",
    WebStringKey.ReasonJavascriptUrlDesc to "JavaScript URL स्कीम पाया गया - क्लिक करने पर कोड निष्पादित होता है",
    WebStringKey.ReasonDataUriTitle to "डेटा URI",
    WebStringKey.ReasonDataUriDesc to "डेटा URI स्कीम पाया गया - इसमें एम्बेडेड दुर्भावनापूर्ण कोड हो सकता है",
    WebStringKey.ReasonAtSymbolInjectionTitle to "@ प्रतीक इंजेक्शन",
    WebStringKey.ReasonAtSymbolInjectionDesc to "URL में @ प्रतीक है जो संभावित क्रेडेंशियल चोरी प्रयास दर्शाता है",
    // HIGH severity
    WebStringKey.ReasonHomographTitle to "होमोग्राफ़ हमला",
    WebStringKey.ReasonHomographDesc to "अंतर्राष्ट्रीय डोमेन नाम (IDN) किसी अन्य डोमेन का प्रतिरूपण कर सकता है",
    WebStringKey.ReasonMixedScriptTitle to "मिश्रित स्क्रिप्ट",
    WebStringKey.ReasonMixedScriptDesc to "होस्टनाम में कई स्क्रिप्ट के अक्षर हैं (संभावित स्पूफ़िंग)",
    WebStringKey.ReasonLookalikeCharsTitle to "समान दिखने वाले अक्षर",
    WebStringKey.ReasonLookalikeCharsDesc to "डोमेन में यूनिकोड अक्षर हैं जो ASCII अक्षरों जैसे दिखते हैं",
    WebStringKey.ReasonZeroWidthCharsTitle to "शून्य-चौड़ाई अक्षर",
    WebStringKey.ReasonZeroWidthCharsDesc to "छिपे हुए शून्य-चौड़ाई यूनिकोड अक्षर पाए गए (अस्पष्टता प्रयास)",
    WebStringKey.ReasonIpHostTitle to "IP होस्ट",
    WebStringKey.ReasonIpHostDesc to "URL डोमेन नाम के बजाय IP पता उपयोग करता है",
    WebStringKey.ReasonCredentialParamTitle to "क्रेडेंशियल पैरामीटर",
    WebStringKey.ReasonCredentialParamDesc to "URL में क्रेडेंशियल-संबंधित पैरामीटर हैं (पासवर्ड, टोकन, आदि)",
    WebStringKey.ReasonBrandImpersonationTitle to "ब्रांड प्रतिरूपण",
    WebStringKey.ReasonBrandImpersonationDesc to "URL किसी ज्ञात ब्रांड का प्रतिरूपण करता प्रतीत होता है",
    WebStringKey.ReasonBrandInSubdomainTitle to "उपडोमेन में ब्रांड",
    WebStringKey.ReasonBrandInSubdomainDesc to "ब्रांड नाम उपडोमेन में है लेकिन मुख्य डोमेन में नहीं",
    WebStringKey.ReasonRiskyExtensionTitle to "जोखिमपूर्ण एक्सटेंशन",
    WebStringKey.ReasonRiskyExtensionDesc to "पथ में संभावित खतरनाक फ़ाइल एक्सटेंशन है",
    WebStringKey.ReasonDoubleExtensionTitle to "दोहरा एक्सटेंशन",
    WebStringKey.ReasonDoubleExtensionDesc to "दोहरा फ़ाइल एक्सटेंशन पाया गया (आम मैलवेयर रणनीति)",
    WebStringKey.ReasonEncodedPayloadTitle to "एन्कोडेड पेलोड",
    WebStringKey.ReasonEncodedPayloadDesc to "URL पैरामीटर में बड़ा एन्कोडेड डेटा पाया गया",
    // MEDIUM severity
    WebStringKey.ReasonHttpNotHttpsTitle to "HTTP HTTPS नहीं",
    WebStringKey.ReasonHttpNotHttpsDesc to "URL असुरक्षित HTTP प्रोटोकॉल उपयोग करता है HTTPS के बजाय",
    WebStringKey.ReasonSuspiciousTldTitle to "संदिग्ध TLD",
    WebStringKey.ReasonSuspiciousTldDesc to "टॉप-लेवल डोमेन अक्सर फ़िशिंग के लिए उपयोग होता है",
    WebStringKey.ReasonHighEntropyHostTitle to "उच्च एन्ट्रॉपी होस्ट",
    WebStringKey.ReasonHighEntropyHostDesc to "डोमेन नाम रैंडमली जेनरेट किया प्रतीत होता है",
    WebStringKey.ReasonRedirectParamTitle to "रीडायरेक्ट पैरामीटर",
    WebStringKey.ReasonRedirectParamDesc to "URL में रीडायरेक्ट पैरामीटर है जो दूसरी साइट पर ले जा सकता है",
    WebStringKey.ReasonDeepSubdomainTitle to "गहरा उपडोमेन",
    WebStringKey.ReasonDeepSubdomainDesc to "अत्यधिक उपडोमेन गहराई (वास्तविक डोमेन छिपा सकती है)",
    WebStringKey.ReasonMultiTldTitle to "मल्टी TLD",
    WebStringKey.ReasonMultiTldDesc to "डोमेन नाम में कई TLD-जैसे खंड",
    WebStringKey.ReasonNumericSubdomainTitle to "संख्यात्मक उपडोमेन",
    WebStringKey.ReasonNumericSubdomainDesc to "केवल-संख्या उपडोमेन पाया गया",
    WebStringKey.ReasonNonStandardPortTitle to "गैर-मानक पोर्ट",
    WebStringKey.ReasonNonStandardPortDesc to "URL गैर-मानक पोर्ट नंबर उपयोग करता है",
    WebStringKey.ReasonSuspiciousPortTitle to "संदिग्ध पोर्ट",
    WebStringKey.ReasonSuspiciousPortDesc to "URL आमतौर पर हमलों से जुड़ा पोर्ट उपयोग करता है",
    WebStringKey.ReasonFragmentHidingTitle to "फ्रैगमेंट छुपाव",
    WebStringKey.ReasonFragmentHidingDesc to "URL फ्रैगमेंट अतिरिक्त सामग्री छुपाता प्रतीत होता है",
    WebStringKey.ReasonExcessiveEncodingTitle to "अत्यधिक एन्कोडिंग",
    WebStringKey.ReasonExcessiveEncodingDesc to "अत्यधिक URL एन्कोडिंग पाई गई (अस्पष्टता प्रयास)",
    WebStringKey.ReasonDomainAgePatternTitle to "डोमेन आयु पैटर्न",
    WebStringKey.ReasonDomainAgePatternDesc to "डोमेन नाम ऑटो-जेनरेटेड डोमेन के पैटर्न से मेल खाता है",
    // LOW severity
    WebStringKey.ReasonUrlShortenerTitle to "URL शॉर्टनर",
    WebStringKey.ReasonUrlShortenerDesc to "URL शॉर्टनिंग सेवा उपयोग करता है (वास्तविक गंतव्य छुपाता है)",
    WebStringKey.ReasonSuspiciousPathTitle to "संदिग्ध पथ",
    WebStringKey.ReasonSuspiciousPathDesc to "पथ में संदिग्ध कीवर्ड हैं (login, verify, आदि)",
    WebStringKey.ReasonLongUrlTitle to "लंबा URL",
    WebStringKey.ReasonLongUrlDesc to "असामान्य रूप से लंबा URL",
    WebStringKey.ReasonCredentialKeywordsTitle to "क्रेडेंशियल कीवर्ड",
    WebStringKey.ReasonCredentialKeywordsDesc to "URL में क्रेडेंशियल हार्वेस्टिंग कीवर्ड हैं",
    // INFO
    WebStringKey.ReasonUnparseableTitle to "अपार्स करने योग्य URL",
    WebStringKey.ReasonUnparseableDesc to "URL को पूरी तरह पार्स नहीं किया जा सका",
    WebStringKey.ReasonAnalysisCompleteTitle to "विश्लेषण पूर्ण",
    WebStringKey.ReasonAnalysisCompleteDesc to "विश्लेषण सफलतापूर्वक पूर्ण हुआ",

    // ML Score Labels
    WebStringKey.MlPhishingScore to "ML फ़िशिंग स्कोर",
    WebStringKey.MlCharacterAnalysis to "अक्षर विश्लेषण",
    WebStringKey.MlFeatureAnalysis to "फ़ीचर विश्लेषण",

    // Unicode Attack Breakdowns (Red Team scenarios)
    WebStringKey.IdnPunycodeDomainTitle to "IDN / Punycode डोमेन",
    WebStringKey.IdnPunycodeDomainDesc to "यह डोमेन अंतर्राष्ट्रीय वर्णों का उपयोग करता है। सुरक्षित प्रदर्शन:",
    WebStringKey.MixedScriptAttackTitle to "मिश्रित स्क्रिप्ट हमला",
    WebStringKey.MixedScriptAttackDesc to "डोमेन में कई लिपियों के वर्ण हैं (जैसे सिरिलिक + लैटिन)। होमोग्राफ हमलों में आम।",
    WebStringKey.ConfusableCharsTitle to "भ्रामक वर्ण",
    WebStringKey.ConfusableCharsDesc to "डोमेन में ऐसे वर्ण हैं जो सामान्य अक्षरों जैसे दिखते हैं (जैसे 'а' बनाम 'a')।"
)

internal val HindiCommonStrings = mapOf(
    "\"Always expand short links before scanning. The bot does this automatically by following redirect headers without rendering the page.\"" to "\"स्कैनिंग से पहले हमेशा छोटे लिंक का विस्तार करें। बॉट पेज को रेंडर किए बिना रीडायरेक्ट हेडर का पालन करके स्वचालित रूप से ऐसा करता है।\"",
    "\"AusPost: Your parcel failed delivery due to incorrect address details. Please update immediately via the link above to avoid return.\"" to "\"ऑसपोस्ट: गलत पते के विवरण के कारण आपके पार्सल की डिलीवरी विफल हो गई। वापसी से बचने के लिए कृपया ऊपर दिए गए लिंक के माध्यम से तुरंत अपडेट करें।\"",
    "\"Commonwealth Bank: Your account has been locked due to suspicious activity. Verify your identity immediately.\"" to "\"कॉमनवेल्थ बैंक: आपका खाता संदिग्ध गतिविधि के कारण लॉक कर दिया गया है। तुरंत अपनी पहचान सत्यापित करें।\"",
    "\"Let's Encrypt (R3)\"" to "\"आइए एन्क्रिप्ट करें (R3)\"",
    "\"Phishing\"" to "\"फ़िशिंग\"",
    "\"You won a \$500 gift card! Click to claim your prize.\"" to "\"आपने \$500 का उपहार कार्ड जीता! अपने पुरस्कार का दावा करने के लिए क्लिक करें।\"",
    "\"Your Apple ID was used to sign in on a new device. If this was not you, verify immediately.\"" to "\"आपकी Apple ID का उपयोग एक नए डिवाइस पर साइन इन करने के लिए किया गया था। यदि यह आप नहीं थे, तो तुरंत सत्यापित करें।\"",
    "\"Your PayPal account has been limited. Please update your information.\"" to "\"आपका PayPal खाता सीमित कर दिया गया है। कृपया अपनी जानकारी अपडेट करें।\"",
    "+10-15 points — Context-dependent signal" to "+10-15 अंक - संदर्भ-निर्भर संकेत",
    "+10-15 points — Suggestive but not conclusive" to "+10-15 अंक - सुझावात्मक लेकिन निर्णायक नहीं",
    "+10-15 points — Suspicious but not definitive" to "+10-15 अंक - संदिग्ध लेकिन निश्चित नहीं",
    "+10-20 points — Contributes to overall risk score" to "+10-20 अंक - समग्र जोखिम स्कोर में योगदान देता है",
    "+15-20 points — Requires caution, not definitive" to "+15-20 अंक - सावधानी की आवश्यकता है, निश्चित नहीं",
    "+15-20 points — Requires destination inspection" to "+15-20 अंक - गंतव्य निरीक्षण की आवश्यकता है",
    "+15-20 points — Security baseline not met" to "+15-20 अंक - सुरक्षा आधार रेखा पूरी नहीं हुई",
    "+20-30 points — Deliberate deception technique" to "+20-30 अंक - जानबूझकर धोखा देने की तकनीक",
    "+20-30 points — Legitimate brands rarely use these" to "+20-30 अंक - वैध ब्रांड शायद ही कभी इनका उपयोग करते हैं",
    "+25-30 points — Strong phishing indicator" to "+25-30 अंक - मजबूत फ़िशिंग संकेतक",
    "+30-35 points — Requires investigation of actual characters" to "+30-35 अंक - वास्तविक पात्रों की जांच की आवश्यकता है",
    "+30-40 points — This is a primary phishing indicator" to "+30-40 अंक - यह एक प्राथमिक फ़िशिंग संकेतक है",
    "+40-50 points — Advanced attack requiring intentional deception" to "+40-50 अंक - उन्नत हमले के लिए जानबूझकर धोखे की आवश्यकता होती है",
    "+5-10 points — Minor signal" to "+5-10 अंक - मामूली संकेत",
    "- Heuristics: {list}" to "- अनुमान: {list}",
    "- Redirects: {count}" to "- रीडायरेक्ट: {count}",
    "- SSL Issuer: {issuer}" to "- एसएसएल जारीकर्ता: {issuer}",
    "- Threat Type: {type}" to "- ख़तरे का प्रकार: {type}",
    "1 hr ago • Phishing" to "1 घंटा पहले • फ़िशिंग",
    "100% offline" to "100% ऑफ़लाइन",
    "2 hours ago" to "2 घंटे पहले",
    "2 mins ago • Safe" to "2 मिनट पहले • सुरक्षित",
    "25+ AI Heuristics" to "25+ एआई अनुमान",
    "3 hops detected involving known URL shorteners." to "ज्ञात यूआरएल शॉर्टनर से जुड़े 3 हॉप्स का पता चला।",
    "3 hrs ago • Safe" to "3 घंटे पहले • सुरक्षित",
    "350 pts" to "350 अंक",
    "400 pts" to "400 अंक",
    "5 hrs ago • Safe" to "5 घंटे पहले • सुरक्षित",
    "< 24 hours" to "<24 घंटे",
    "A phishing attempt was successfully blocked" to "फ़िशिंग प्रयास को सफलतापूर्वक अवरुद्ध कर दिया गया",
    "A shorter, cleaner URL would reduce this signal contribution by ~8 points." to "एक छोटा, साफ़ यूआरएल इस सिग्नल योगदान को ~8 अंक तक कम कर देगा।",
    "AD" to "विज्ञापन",
    "AI-powered phishing detection running 100% offline in your browser." to "AI-संचालित फ़िशिंग पहचान आपके ब्राउज़र में 100% ऑफ़लाइन चल रही है।",
    "AI-powered phishing detection that runs" to "एआई-संचालित फ़िशिंग डिटेक्शन जो चलता है",
    "AM" to "पूर्वाह्न",
    "About Mehr Guard" to "[[ब्रांड]] के बारे में",
    "Accuracy" to "शुद्धता",
    "Accuracy:" to "शुद्धता:",
    "Acknowledgements" to "स्वीकृतियाँ",
    "Active" to "सक्रिय",
    "Active Protection" to "सक्रिय सुरक्षा",
    "Active Scanner" to "सक्रिय स्कैनर",
    "Actual Punycode (Where it goes)" to "वास्तविक पुनीकोड ​​(यह कहां जाता है)",
    "Add Domain" to "डोमेन जोड़ें",
    "Add manually" to "मैन्युअल रूप से जोड़ें",
    "Add to Allowlist" to "अनुमति सूची में जोड़ें",
    "Add to Blocklist" to "ब्लॉकलिस्ट में जोड़ें",
    "Added 1 week ago" to "1 सप्ताह पहले जोड़ा गया",
    "Added 2 days ago" to "2 दिन पहले जोड़ा गया",
    "Added {domain} to {list}" to "{domain} को {list} में जोड़ा गया",
    "Adjust heuristic thresholds. Higher sensitivity may increase false positives." to "अनुमानी सीमाएँ समायोजित करें. उच्च संवेदनशीलता झूठी सकारात्मकता को बढ़ा सकती है।",
    "Alex Chen" to "एलेक्स चेन",
    "Alex Morgan" to "एलेक्स मॉर्गन",
    "Alexa Top 1000 site" to "एलेक्सा टॉप 1000 साइट",
    "All URLs will show as MALICIOUS for demo purposes" to "डेमो प्रयोजनों के लिए सभी यूआरएल दुर्भावनापूर्ण के रूप में दिखाई देंगे",
    "All code execution happens in an ephemeral container that is destroyed after each scan. This ensures malicious payloads can never escape to your system." to "सभी कोड निष्पादन एक अल्पकालिक कंटेनर में होता है जो प्रत्येक स्कैन के बाद नष्ट हो जाता है। यह सुनिश्चित करता है कि दुर्भावनापूर्ण पेलोड आपके सिस्टम से कभी बच न सकें।",
    "All notifications marked as read" to "सभी सूचनाओं को पठित के रूप में चिह्नित किया गया",
    "Allow List" to "सूची की अनुमति दें",
    "Allowlist" to "अनुमति सूची",
    "Analysed offline." to "ऑफ़लाइन विश्लेषण किया गया.",
    "Analysis" to "विश्लेषण",
    "Analysis Complete" to "विश्लेषण पूर्ण",
    "Analysis Engine Loading..." to "विश्लेषण इंजन लोड हो रहा है...",
    "Analysis Summary" to "विश्लेषण सारांश",
    "Analysis Time" to "विश्लेषण का समय",
    "Analyze" to "विश्लेषण करें",
    "Analyze This URL" to "इस यूआरएल का विश्लेषण करें",
    "Analyze URL" to "यूआरएल का विश्लेषण करें",
    "Analyzed offline in <5ms" to "<5ms में ऑफ़लाइन विश्लेषण किया गया",
    "Analyzing offline..." to "ऑफ़लाइन विश्लेषण किया जा रहा है...",
    "Anonymous Telemetry" to "अनाम टेलीमेट्री",
    "Anonymous Telemetry disabled" to "अनाम टेलीमेट्री अक्षम",
    "Anonymous Telemetry enabled" to "अनाम टेलीमेट्री सक्षम",
    "Apple Support" to "एप्पल समर्थन",
    "Apple only uses apple.com for all account-related activities. Be wary of domains containing brand names but with different extensions." to "Apple सभी खाता-संबंधित गतिविधियों के लिए केवल apple.com का उपयोग करता है। उन डोमेन से सावधान रहें जिनमें ब्रांड नाम तो हैं लेकिन अलग-अलग एक्सटेंशन हैं।",
    "Apple would never use a third-party domain for account verification. Check the actual domain name." to "Apple खाता सत्यापन के लिए कभी भी तृतीय-पक्ष डोमेन का उपयोग नहीं करेगा। वास्तविक डोमेन नाम की जाँच करें.",
    "Are you sure you want to end this session? Progress will be lost." to "क्या आप वाकई इस सत्र को समाप्त करना चाहते हैं? प्रगति खो जाएगी.",
    "Atlassian" to "एटलसियन",
    "Atlassian is a legitimate software company. Their primary domain atlassian.com is trustworthy." to "एटलसियन एक वैध सॉफ्टवेयर कंपनी है। उनका प्राथमिक डोमेन atlassian.com भरोसेमंद है।",
    "Attack Breakdown" to "आक्रमण टूटना",
    "Attackers create domains that look like trusted brands to steal credentials" to "क्रेडेंशियल चुराने के लिए हमलावर ऐसे डोमेन बनाते हैं जो विश्वसनीय ब्रांड की तरह दिखते हैं",
    "Auto-Block Threats" to "खतरों को ऑटो-ब्लॉक करें",
    "Auto-Copy Safe Links" to "ऑटो-कॉपी सुरक्षित लिंक",
    "Auto-Copy Safe Links disabled" to "सुरक्षित लिंक की स्वतः प्रतिलिपि अक्षम की गई",
    "Auto-Copy Safe Links enabled" to "ऑटो-कॉपी सुरक्षित लिंक सक्षम",
    "Automatically block high-risk URLs" to "उच्च जोखिम वाले यूआरएल को स्वचालित रूप से ब्लॉक करें",
    "Back online" to "वापस ऑनलाइन",
    "Back to Dashboard" to "डैशबोर्ड पर वापस जाएँ",
    "Balanced" to "संतुलित",
    "Balanced Mode (Recommended)" to "संतुलित मोड (अनुशंसित)",
    "Beat the Bot" to "बॉट को मारो",
    "Beat the Bot →" to "बॉट को मारो →",
    "Best Streak" to "सर्वश्रेष्ठ स्ट्रीक",
    "Blacklist Match" to "ब्लैकलिस्ट मिलान",
    "Blacklist Status" to "ब्लैकलिस्ट स्थिति",
    "Block & Report" to "ब्लॉक करें और रिपोर्ट करें",
    "Blocklist" to "ब्लॉकलिस्ट",
    "Bot Score" to "बॉट स्कोर",
    "Brand Impersonation" to "ब्रांड प्रतिरूपण",
    "Brand Impersonation Detected" to "ब्रांड प्रतिरूपण का पता लगाया गया",
    "Brands Detected" to "ब्रांड का पता लगाया गया",
    "Browser Preview" to "ब्राउज़र पूर्वावलोकन",
    "Built for" to "के लिए बनाया गया",
    "CLEAN" to "साफ",
    "CRITICAL" to "गंभीर",
    "Camera API (QR scanning unavailable)" to "कैमरा एपीआई (क्यूआर स्कैनिंग अनुपलब्ध)",
    "Camera Access Required" to "कैमरा पहुंच आवश्यक है",
    "Camera Not Available" to "कैमरा उपलब्ध नहीं है",
    "Camera activated" to "कैमरा सक्रिय",
    "Camera error: {error}" to "कैमरा त्रुटि: {error}",
    "Camera not supported in this browser" to "इस ब्राउज़र में कैमरा समर्थित नहीं है",
    "Camera permission denied" to "कैमरे की अनुमति अस्वीकृत",
    "Can redirect through tracking or to malicious destinations" to "ट्रैकिंग के माध्यम से या दुर्भावनापूर्ण गंतव्यों पर पुनर्निर्देशित किया जा सकता है",
    "Cancel" to "रद्द करना",
    "Caution" to "सावधानी",
    "Caution Advised" to "सावधानी की सलाह दी गई",
    "Certificate Issuer matches domain owner (DigiCert Inc)" to "प्रमाणपत्र जारीकर्ता डोमेन स्वामी से मेल खाता है (DigiCert Inc)",
    "Certificate Issuer matches domain owner (DigiCert Inc)." to "प्रमाणपत्र जारीकर्ता डोमेन स्वामी (DigiCert Inc) से मेल खाता है।",
    "Certificate issued by DigiCert Inc. No anomalies in chain of trust." to "डिजीसर्ट इंक द्वारा जारी प्रमाणपत्र। विश्वास की श्रृंखला में कोई विसंगति नहीं।",
    "Certificate issued by trusted CA. No anomalies in chain of trust." to "विश्वसनीय सीए द्वारा जारी प्रमाण पत्र। विश्वास की श्रृंखला में कोई विसंगति नहीं.",
    "Certificate recently issued or self-signed. Proceed with caution." to "प्रमाणपत्र हाल ही में जारी किया गया या स्व-हस्ताक्षरित। सावधानी के साथ आगे बढ़ना।",
    "Challenge our offline AI engine. Can you spot the phish faster?" to "हमारे ऑफ़लाइन AI इंजन को चुनौती दें। क्या आप मछली को तेजी से पहचान सकते हैं?",
    "Characters like Cyrillic \"а\" look identical to Latin \"a\" but are different" to "सिरिलिक \"ए\" जैसे अक्षर लैटिन \"ए\" के समान दिखते हैं लेकिन भिन्न हैं",
    "Check for Updates" to "अद्यतन के लिए जाँच",
    "Check the domain carefully. This appears to be a well-known, trusted domain." to "डोमेन को ध्यान से जांचें. यह एक प्रसिद्ध, विश्वसनीय डोमेन प्रतीत होता है।",
    "Choose Format" to "प्रारूप चुनें",
    "Clear All" to "सभी साफ करें",
    "Clear History" to "इतिहास मिटा दें",
    "Clear scan history?" to "स्कैन इतिहास साफ़ करें?",
    "Click a sample below or paste any URL:" to "नीचे एक नमूना क्लिक करें या कोई यूआरएल पेस्ट करें:",
    "Close" to "बंद करना",
    "Code execution happens in an ephemeral container. Malicious payloads never touch your OS kernel." to "कोड निष्पादन एक अल्पकालिक कंटेनर में होता है। दुर्भावनापूर्ण पेलोड कभी भी आपके OS कर्नेल को नहीं छूते।",
    "Combined with other signals, suggests intent to steal credentials" to "अन्य संकेतों के साथ मिलकर, क्रेडेंशियल्स चुराने के इरादे का पता चलता है",
    "Compact View" to "कॉम्पैक्ट दृश्य",
    "Compact view" to "कॉम्पैक्ट दृश्य",
    "Complete analysis is performed locally. Your camera feed and scanned data never touch an external server, ensuring absolute privacy." to "संपूर्ण विश्लेषण स्थानीय स्तर पर किया जाता है. पूर्ण गोपनीयता सुनिश्चित करते हुए, आपका कैमरा फ़ीड और स्कैन किया गया डेटा कभी भी किसी बाहरी सर्वर को नहीं छूता है।",
    "Confidence Score" to "आत्मविश्वास स्कोर",
    "Confidence score" to "आत्मविश्वास स्कोर",
    "Confidence: 99.8%" to "आत्मविश्वास: 99.8%",
    "Configure formats and download your threat analysis." to "प्रारूप कॉन्फ़िगर करें और अपना खतरा विश्लेषण डाउनलोड करें।",
    "Congratulations! You beat the bot!" to "बधाई हो! आपने बॉट को हरा दिया!",
    "Continue Anyway" to "फिर भी जारी रखें",
    "Copy" to "प्रतिलिपि",
    "Copy Link" to "लिंक की प्रतिलिपि करें",
    "Copy trusted URLs to clipboard." to "विश्वसनीय यूआरएल को क्लिपबोर्ड पर कॉपी करें।",
    "Core v2.4.1 • Build 2024.12.19" to "कोर v2.4.1 • बिल्ड 2024.12.19",
    "Correct Decision!" to "सही निर्णय!",
    "Correct!" to "सही!",
    "Could not save theme preference:" to "थीम प्राथमिकता सहेजी नहीं जा सकी:",
    "Couldn\\'t Read QR Code" to "QR कोड नहीं पढ़ सका",
    "Credential Harvesting Path" to "क्रेडेंशियल हार्वेस्टिंग पथ",
    "Credential Harvesting Path (/login)" to "क्रेडेंशियल हार्वेस्टिंग पथ (/लॉगिन)",
    "Current" to "मौजूदा",
    "Cyrillic characters mimicking Latin alphabet detected." to "लैटिन वर्णमाला की नकल करने वाले सिरिलिक वर्णों का पता चला।",
    "DB CHECK" to "डीबी चेक",
    "DISCONNECTED" to "डिस्कनेक्ट किया गया",
    "DO NOT VISIT" to "यात्रा न करें",
    "DOMAIN" to "कार्यक्षेत्र",
    "Dangerous" to "खतरनाक",
    "Dark" to "अँधेरा",
    "Dashboard" to "डैशबोर्ड",
    "Data Lifecycle Verification" to "डेटा जीवनचक्र सत्यापन",
    "Data Point" to "डेटा प्वाइंट",
    "Data exported successfully!" to "डेटा सफलतापूर्वक निर्यात किया गया!",
    "Data sent without encryption can be intercepted" to "बिना एन्क्रिप्शन के भेजा गया डेटा इंटरसेप्ट किया जा सकता है",
    "Database Updated" to "डेटाबेस अपडेट किया गया",
    "Decoded URL/Payload" to "डिकोड किया गया यूआरएल/पेलोड",
    "Deep subdomains can hide the actual domain at the end" to "डीप उपडोमेन अंत में वास्तविक डोमेन को छिपा सकते हैं",
    "Destination URL obfuscated. Unable to verify final target." to "गंतव्य URL अस्पष्ट है. अंतिम लक्ष्य सत्यापित करने में असमर्थ.",
    "Details" to "विवरण",
    "Detection" to "खोज",
    "Deutsch" to "deutsch",
    "Disable all external link previews." to "सभी बाहरी लिंक पूर्वावलोकन अक्षम करें.",
    "Display" to "प्रदर्शन",
    "Display threat probability percentage" to "ख़तरे की संभावना प्रतिशत प्रदर्शित करें",
    "Do Not Visit This URL" to "इस यूआरएल पर न जाएं",
    "Domain \"apple-id-verify.com\" is not owned by Apple" to "डोमेन \"apple-id-verify.com\" Apple के स्वामित्व में नहीं है",
    "Domain age > 5 years (High trust)." to "डोमेन आयु > 5 वर्ष (उच्च विश्वास)।",
    "Domain age is less than 24 hours." to "डोमेन की आयु 24 घंटे से कम है.",
    "Domain already in list" to "डोमेन पहले से ही सूची में है",
    "Domain contains \"xn--\" IDN encoding" to "डोमेन में \"xn--\" IDN एन्कोडिंग शामिल है",
    "Domain contains or mimics a known brand name (PayPal, Amazon, etc.)" to "डोमेन में एक ज्ञात ब्रांड नाम शामिल है या उसकी नकल करता है (PayPal, Amazon, आदि)",
    "Domain mimics known brand (PayPal → Paypa1). High-confidence phishing." to "डोमेन ज्ञात ब्रांड (PayPal → Paypa1) की नकल करता है। उच्च आत्मविश्वास वाली फ़िशिंग.",
    "Domain mimics legitimate bank (commbank.com.au)" to "डोमेन वैध बैंक की नकल करता है (commbank.com.au)",
    "Domain or path contains random-looking character sequences" to "डोमेन या पथ में यादृच्छिक दिखने वाले वर्ण अनुक्रम होते हैं",
    "Domain registered > 5 years ago. Low probability of churn-and-burn." to "डोमेन पंजीकृत > 5 वर्ष पहले. मंथन और जलने की कम संभावना.",
    "Domain registered in the last 24 hours" to "पिछले 24 घंटों में डोमेन पंजीकृत हुआ",
    "Domain uses common misspellings or character substitutions (paypa1, amaz0n)" to "डोमेन सामान्य गलत वर्तनी या वर्ण प्रतिस्थापन का उपयोग करता है (paypa1, amaz0n)",
    "Domain uses suspicious hyphenated structure (verify-deliveries.net)" to "डोमेन संदिग्ध हाइफ़नेटेड संरचना का उपयोग करता है (verify-deliveries.net)",
    "Don't just get a \"Block\". We provide detailed heuristic breakdowns of URL parameters, redirects, and javascript payloads." to "बस एक \"ब्लॉक\" न प्राप्त करें। हम यूआरएल पैरामीटर, रीडायरेक्ट और जावास्क्रिप्ट पेलोड का विस्तृत अनुमानी विश्लेषण प्रदान करते हैं।",
    "Download Apps" to "ऐप्स डाउनलोड करें",
    "Drag & Drop QR code image here" to "क्यूआर कोड छवि को यहां खींचें और छोड़ें",
    "Drag & drop a QR code image here or enable camera access to start scanning." to "क्यूआर कोड छवि को यहां खींचें और छोड़ें या स्कैनिंग शुरू करने के लिए कैमरा एक्सेस सक्षम करें।",
    "Educational Note" to "शैक्षिक नोट",
    "Embedded Redirect" to "एंबेडेड रीडायरेक्ट",
    "Enable Camera" to "कैमरा सक्षम करें",
    "Enable camera first" to "पहले कैमरा सक्षम करें",
    "End Session" to "समापन सत्र",
    "Engine" to "इंजन",
    "Engine Active" to "इंजन सक्रिय",
    "Engine Active (Offline)" to "इंजन सक्रिय (ऑफ़लाइन)",
    "Engine initializing, please wait..." to "इंजन प्रारंभ हो रहा है, कृपया प्रतीक्षा करें...",
    "Engine initializing..." to "इंजन प्रारंभ हो रहा है...",
    "Engine not ready, using demo mode" to "इंजन तैयार नहीं है, डेमो मोड का उपयोग किया जा रहा है",
    "English" to "अंग्रेज़ी",
    "Enter" to "प्रवेश करना",
    "Enter URL" to "यूआरएल दर्ज करें",
    "Enter URL Manually" to "URL मैन्युअल रूप से दर्ज करें",
    "Enterprise Plan" to "उद्यम योजना",
    "Enterprise Protection Active" to "एंटरप्राइज़ सुरक्षा सक्रिय",
    "Esc" to "ईएससी",
    "Escape" to "पलायन",
    "Español" to "Español",
    "Established Domain" to "स्थापित डोमेन",
    "Excessive Subdomains" to "अत्यधिक उपडोमेन",
    "Excessively Long URL" to "अत्यधिक लंबा यूआरएल",
    "Exit" to "बाहर निकलना",
    "Explainable Defence." to "समझाने योग्य बचाव।",
    "Explainable Security" to "समझाने योग्य सुरक्षा",
    "Export" to "निर्यात",
    "Export Report" to "निर्यात रिपोर्ट",
    "Export Reports" to "निर्यात रिपोर्ट",
    "Exports include all identified threat vectors, headers, and the raw payload analysis." to "निर्यात में सभी पहचाने गए खतरे वाले वैक्टर, हेडर और कच्चे पेलोड विश्लेषण शामिल हैं।",
    "External Transmission" to "बाह्य संचरण",
    "FAIL" to "असफल",
    "Failed to copy link" to "लिंक कॉपी करने में विफल",
    "Failed to copy report" to "रिपोर्ट कॉपी करने में विफल",
    "Failed to get scan statistics:" to "स्कैन आँकड़े प्राप्त करने में विफल:",
    "Failed to load image" to "छवि लोड करने में विफल",
    "Failed to read file" to "फ़ाइल पढ़ने में विफल",
    "Failed to share" to "साझा करने में विफल",
    "Failed to share report" to "रिपोर्ट साझा करने में विफल",
    "File upload (image scanning unavailable)" to "फ़ाइल अपलोड (छवि स्कैनिंग अनुपलब्ध)",
    "Final Destination" to "अंतिम गंतव्य",
    "Final Results" to "अंतिम परिणाम",
    "Fix it" to "इसे ठीक करें",
    "For the best experience, use Chrome, Firefox, Safari, or Edge." to "सर्वोत्तम अनुभव के लिए, Chrome, Firefox, Safari, या Edge का उपयोग करें।",
    "Found in 3 local offline threat databases." to "3 स्थानीय ऑफ़लाइन ख़तरे वाले डेटाबेस में पाया गया।",
    "Français" to "फ़्रांसीसी",
    "Free/cheap TLDs are heavily abused for throwaway phishing domains" to "मुफ़्त/सस्ते टीएलडी का फ़िशिंग डोमेन के लिए भारी दुरुपयोग किया जाता है",
    "Gallery" to "गैलरी",
    "Game Over!" to "खेल खत्म!",
    "Generate Test QR" to "परीक्षण क्यूआर उत्पन्न करें",
    "Generate a test malicious QR code" to "एक परीक्षण दुर्भावनापूर्ण QR कोड जनरेट करें",
    "Generated on Dec 29, 2025 • 14:32:01 UTC" to "29 दिसंबर 2025 को उत्पन्न • 14:32:01 यूटीसी",
    "Generated on {date} • {time} UTC" to "{date} • {time} UTC पर उत्पन्न",
    "Generating {format} report..." to "{format} रिपोर्ट तैयार की जा रही है...",
    "Get Started! 🚀" to "शुरू हो जाओ! 🚀",
    "GitHub" to "GitHub",
    "GitHub.com is a legitimate developer platform owned by Microsoft. Always verify the exact domain spelling." to "GitHub.com Microsoft के स्वामित्व वाला एक वैध डेवलपर प्लेटफ़ॉर्म है। हमेशा सटीक डोमेन वर्तनी सत्यापित करें।",
    "Gmail" to "जीमेल लगीं",
    "Google Docs" to "गूगल डॉक्स",
    "Google Docs uses docs.google.com. Always verify the sender knows you before opening shared documents." to "Google डॉक्स docs.google.com का उपयोग करता है। साझा किए गए दस्तावेज़ खोलने से पहले हमेशा सत्यापित करें कि प्रेषक आपको जानता है।",
    "Google services use subdomains of google.com. mail.google.com is the legitimate Gmail address." to "Google सेवाएँ google.com के उपडोमेन का उपयोग करती हैं। mail.google.com वैध जीमेल पता है।",
    "Got it" to "समझ गया",
    "HIGH" to "उच्च",
    "HIGH RISK" to "भारी जोखिम",
    "HIGH RISK DETECTED" to "उच्च जोखिम का पता चला",
    "HTTP instead of HTTPS (no encryption)" to "HTTPS के बजाय HTTP (कोई एन्क्रिप्शन नहीं)",
    "HTTPS" to "HTTPS के",
    "Help" to "मदद",
    "Heuristic Engine" to "अनुमानी इंजन",
    "Heuristics" to "heuristics",
    "Hides the true destination URL from the user" to "उपयोगकर्ता से वास्तविक गंतव्य URL छुपाता है",
    "High" to "उच्च",
    "High Entropy" to "उच्च एन्ट्रापी",
    "High Risk" to "भारी जोखिम",
    "High entropy string detected in URL parameters." to "यूआरएल पैरामीटर में उच्च एन्ट्रापी स्ट्रिंग का पता चला।",
    "High-Performance Engine" to "उच्च प्रदर्शन इंजन",
    "High-Risk TLD" to "उच्च जोखिम वाला टीएलडी",
    "High-Risk URL Blocked" to "उच्च जोखिम वाला यूआरएल ब्लॉक किया गया",
    "High-confidence phishing detected. This URL exhibits multiple malicious indicators." to "हाई-कॉन्फिडेंस फ़िशिंग का पता चला. यह यूआरएल अनेक दुर्भावनापूर्ण संकेतक प्रदर्शित करता है।",
    "Hold steady. Analysed offline in <5ms." to "स्थिर रहो. <5ms में ऑफ़लाइन विश्लेषण किया गया।",
    "Home" to "घर",
    "Homograph / IDN Attack" to "होमोग्राफ/आईडीएन हमला",
    "Homograph Attack" to "होमोग्राफ हमला",
    "Homograph attack: \"c0mmonwealth\" uses zero instead of letter O" to "होमोग्राफ हमला: \"c0mmonwealth\" अक्षर O के स्थान पर शून्य का उपयोग करता है",
    "Homograph attack: \"paypa1\" uses number 1 instead of letter L" to "होमोग्राफ हमला: \"पेपा1\" अक्षर एल के बजाय नंबर 1 का उपयोग करता है",
    "Homograph attacks use similar-looking characters. Always check URLs character by character for suspicious substitutions." to "होमोग्राफ हमलों में समान दिखने वाले पात्रों का उपयोग किया जाता है। संदिग्ध प्रतिस्थापनों के लिए हमेशा यूआरएल को अक्षर दर अक्षर जांचें।",
    "How aggressive should threat detection be?" to "खतरे का पता लगाना कितना आक्रामक होना चाहिए?",
    "Human-Readable Report" to "मानव-पठनीय रिपोर्ट",
    "I am reporting a suspected phishing URL detected by Mehr Guard:" to "मैं Mehr Guard द्वारा खोजे गए एक संदिग्ध फ़िशिंग URL की रिपोर्ट कर रहा हूँ:",
    "ID: scan_2025_12_29_h9t2" to "आईडी: scan_2025_12_29_h9t2",
    "ID: {id}" to "आईडी: {id}",
    "INFO" to "जानकारी",
    "IP Address Host" to "आईपी ​​एड्रेस होस्ट",
    "If HTTPS was used, this signal would not trigger and score would drop by ~18 points." to "यदि HTTPS का उपयोग किया जाता, तो यह सिग्नल ट्रिगर नहीं होता और स्कोर ~18 अंक कम हो जाता।",
    "If a registered domain name was used instead of IP address, score would drop by ~28 points." to "यदि आईपी पते के स्थान पर पंजीकृत डोमेन नाम का उपयोग किया जाता, तो स्कोर ~28 अंक कम हो जाता।",
    "If all characters were ASCII Latin letters, this signal would not trigger and score would drop by ~45 points." to "यदि सभी अक्षर ASCII लैटिन अक्षर होते, तो यह संकेत ट्रिगर नहीं होता और स्कोर ~45 अंक कम हो जाता।",
    "If no embedded URLs were present in query parameters, score would drop by ~18 points." to "यदि क्वेरी पैरामीटर में कोई एम्बेडेड यूआरएल मौजूद नहीं था, तो स्कोर ~18 अंक कम हो जाएगा।",
    "If only 1-2 subdomains were used, this signal would not trigger. Score would drop by ~12 points." to "यदि केवल 1-2 उपडोमेन का उपयोग किया जाता, तो यह सिग्नल ट्रिगर नहीं होता। स्कोर ~12 अंक कम हो जाएगा।",
    "If the domain spelled the brand correctly without substitutions, score would drop by ~25 points." to "यदि डोमेन ने प्रतिस्थापन के बिना ब्रांड की सही वर्तनी लिखी है, तो स्कोर ~25 अंक कम हो जाएगा।",
    "If the domain used only ASCII characters (no IDN), score would drop by ~32 points." to "यदि डोमेन केवल ASCII वर्ण (कोई IDN नहीं) का उपयोग करता है, तो स्कोर ~32 अंक कम हो जाएगा।",
    "If the domain used readable words instead of random characters, score would drop by ~12 points." to "यदि डोमेन यादृच्छिक वर्णों के बजाय पठनीय शब्दों का उपयोग करता है, तो स्कोर ~12 अंक कम हो जाएगा।",
    "If the full destination URL was visible, score would drop by ~18 points (assuming destination is safe)." to "यदि पूरा गंतव्य यूआरएल दिखाई देता है, तो स्कोर ~18 अंक कम हो जाएगा (यह मानते हुए कि गंतव्य सुरक्षित है)।",
    "If this URL used .com, .org, or country TLDs, score would drop by ~25 points." to "यदि इस URL में .com, .org, या देश TLDs का उपयोग किया जाता है, तो स्कोर ~25 अंक कम हो जाएगा।",
    "If this were the official brand domain (paypal.com), this signal would not trigger and score would drop by ~35 points." to "यदि यह आधिकारिक ब्रांड डोमेन (paypal.com) होता, तो यह सिग्नल ट्रिगर नहीं होता और स्कोर ~35 अंक कम हो जाता।",
    "Import Image" to "छवि आयात करें",
    "Imported: {name}" to "आयातित: {name}",
    "Incoming Message (+61 491 570 010):" to "आने वाला संदेश (+61 491 570 010):",
    "Incorrect Decision" to "ग़लत निर्णय",
    "Intermediate Hop" to "इंटरमीडिएट हॉप",
    "International domains can hide malicious lookalike characters" to "अंतर्राष्ट्रीय डोमेन दुर्भावनापूर्ण समान दिखने वाले पात्रों को छुपा सकते हैं",
    "Invalid URL Format" to "अमान्य यूआरएल प्रारूप",
    "Invalid URL format" to "अमान्य यूआरएल प्रारूप",
    "Invalid theme:" to "अमान्य थीम:",
    "Isolated Sandbox" to "पृथक सैंडबॉक्स",
    "It's a Tie!" to "यह एक टाई है!",
    "JS" to "जे एस",
    "JSON format. Best for SIEM integration." to "JSON प्रारूप. सिएम एकीकरण के लिए सर्वोत्तम।",
    "JSON report downloaded" to "JSON रिपोर्ट डाउनलोड की गई",
    "John Smith" to "जॉन स्मिथ",
    "Judge Mode" to "जज मोड",
    "Judge Mode Active" to "जज मोड सक्रिय",
    "Judge Mode OFF - Normal detection active" to "जज मोड बंद - सामान्य पहचान सक्रिय",
    "Judge Mode: Force MALICIOUS results for demo" to "जज मोड: डेमो के लिए दुर्भावनापूर्ण परिणामों को बलपूर्वक लागू करें",
    "Judge Mode: ON" to "जज मोड: चालू",
    "Just now" to "बस अब ",
    "Kotlin Multiplatform" to "कोटलिन मल्टीप्लेटफ़ॉर्म",
    "Kotlin engine not ready yet" to "कोटलिन इंजन अभी तैयार नहीं है",
    "Kotlin/Wasm" to "कोटलिन/वासम",
    "KotlinConf Student Competition 2025-2026" to "कोटलिनकॉन्फ़ छात्र प्रतियोगिता 2025-2026",
    "LIVE" to "रहना",
    "LIVE FEED ACTIVE" to "लाइव फ़ीड सक्रिय",
    "LIVE FEED DISCONNECTED" to "लाइव फ़ीड डिस्कनेक्ट हो गया",
    "LOW" to "कम",
    "LOW RISK" to "कम जोखिम",
    "Language: {language} {flag}" to "भाषा: {language} {flag}",
    "Last Update" to "आखिरी अपडेट",
    "Latency" to "विलंब",
    "Latency: 2ms" to "विलंबता: 2ms",
    "Learn about our local architecture" to "हमारी स्थानीय वास्तुकला के बारे में जानें",
    "Learn how to identify advanced QR homograph attacks." to "उन्नत क्यूआर होमोग्राफ़ हमलों की पहचान करना सीखें।",
    "Legitimate" to "वैध",
    "Legitimate services use domains; IPs hide identity and bypass filters" to "वैध सेवाएँ डोमेन का उपयोग करती हैं; आईपी ​​पहचान छिपाते हैं और फ़िल्टर को बायपास करते हैं",
    "Let's Encrypt (R3)" to "आइए एन्क्रिप्ट करें (R3)",
    "Light" to "रोशनी",
    "Limited Browser Support" to "सीमित ब्राउज़र समर्थन",
    "Link copied to clipboard!" to "लिंक क्लिपबोर्ड पर कॉपी किया गया!",
    "LinkedIn" to "Linkedin",
    "LinkedIn uses linkedin.com as their primary domain. Profile URLs follow the /in/username format." to "लिंक्डइन अपने प्राथमिक डोमेन के रूप में linksin.com का उपयोग करता है। प्रोफ़ाइल URL /in/उपयोगकर्ता नाम प्रारूप का पालन करते हैं।",
    "Live Hint" to "लाइव संकेत",
    "Live Preview" to "लाइव पूर्वावलोकन",
    "Live Scanner" to "लाइव स्कैनर",
    "Live Scoreboard" to "लाइव स्कोरबोर्ड",
    "Local DB" to "स्थानीय डी.बी",
    "Local Database" to "स्थानीय डेटाबेस",
    "Local Memory (RAM)" to "स्थानीय मेमोरी (रैम)",
    "Local Privacy" to "स्थानीय गोपनीयता",
    "Local Sandbox" to "स्थानीय सैंडबॉक्स",
    "Local database v2.4.1 active. No data leaves this device." to "स्थानीय डेटाबेस v2.4.1 सक्रिय। इस डिवाइस से कोई डेटा नहीं छूटता.",
    "Local storage (history won\\'t persist)" to "स्थानीय भंडारण (इतिहास कायम नहीं रहेगा)",
    "Long URLs can hide malicious parameters or overwhelm users" to "लंबे URL दुर्भावनापूर्ण पैरामीटर छिपा सकते हैं या उपयोगकर्ताओं को परेशान कर सकते हैं",
    "Look at the domain carefully. Is \"c0mmonwealth\" spelled correctly? The number 0 is often used to replace the letter O." to "डोमेन को ध्यान से देखें. क्या \"c0mmonwealth\" की वर्तनी सही है? संख्या 0 का प्रयोग अक्सर अक्षर O के स्थान पर किया जाता है।",
    "Look at the domain name carefully. Is \"paypa1\" spelled correctly?" to "डोमेन नाम को ध्यान से देखें. क्या \"paypa1\" की वर्तनी सही है?",
    "Look closely at the domain structure. Legitimate organisations rarely use hyphens in the main domain name or generic TLDs like" to "डोमेन संरचना को बारीकी से देखें. वैध संगठन शायद ही कभी मुख्य डोमेन नाम या जेनेरिक टीएलडी जैसे हाइफ़न का उपयोग करते हैं",
    "Low" to "कम",
    "Low Risk" to "कम जोखिम",
    "Low Sensitivity Mode" to "कम संवेदनशीलता मोड",
    "MALICIOUS" to "दुर्भावनापूर्ण",
    "MEDIUM" to "मध्यम",
    "MEDIUM RISK" to "मध्यम जोखिम",
    "MINOR CONCERNS" to "छोटी-मोटी चिंताएँ",
    "Machine-Readable" to "मशीन पठनीय",
    "Make your decision" to "अपना निर्णय लें",
    "Malicious" to "दुर्भावनापूर्ण",
    "Manage privacy controls, sensitivity, and security lists." to "गोपनीयता नियंत्रण, संवेदनशीलता और सुरक्षा सूचियाँ प्रबंधित करें।",
    "Matched 3 signatures in local phishing DB." to "स्थानीय फ़िशिंग डीबी में 3 हस्ताक्षरों का मिलान किया गया।",
    "Maximum protection. Blocks any suspicious patterns including newly registered domains, uncommon TLDs, and any URL with potential encoding tricks." to "अधिकतम सुरक्षा. नए पंजीकृत डोमेन, असामान्य टीएलडी और संभावित एन्कोडिंग ट्रिक्स वाले किसी भी यूआरएल सहित किसी भी संदिग्ध पैटर्न को ब्लॉक करता है।",
    "Medium" to "मध्यम",
    "Microsoft-owned platform" to "माइक्रोसॉफ्ट के स्वामित्व वाला मंच",
    "Missing features:" to "अनुपलब्ध विशेषताएं:",
    "More than 3 subdomain levels (secure.login.paypal.fake.com)" to "3 से अधिक उपडोमेन स्तर (secure.login.paypal.fake.com)",
    "Need help? Visit our GitHub for documentation" to "मदद की ज़रूरत है? दस्तावेज़ीकरण के लिए हमारे GitHub पर जाएँ",
    "Never trust shortened URLs from unknown sources. Use URL expander tools to see the real destination before clicking." to "अज्ञात स्रोतों से प्राप्त संक्षिप्त यूआरएल पर कभी भरोसा न करें। क्लिक करने से पहले वास्तविक गंतव्य देखने के लिए यूआरएल विस्तारक टूल का उपयोग करें।",
    "Newly Registered Domain" to "नव पंजीकृत डोमेन",
    "Next Round" to "अगला दौर",
    "Next →" to "अगला →",
    "No Cloud Logs" to "कोई क्लाउड लॉग नहीं",
    "No HTTPS Encryption" to "कोई HTTPS एन्क्रिप्शन नहीं",
    "No HTTPS encryption" to "कोई HTTPS एन्क्रिप्शन नहीं",
    "No QR code found in image" to "छवि में कोई क्यूआर कोड नहीं मिला",
    "No URL to copy" to "कॉपी करने के लिए कोई यूआरएल नहीं",
    "No URL to open" to "खोलने के लिए कोई यूआरएल नहीं",
    "No URL to report - analyze one first" to "रिपोर्ट करने के लिए कोई URL नहीं - पहले एक का विश्लेषण करें",
    "No camera found" to "कोई कैमरा नहीं मिला",
    "No custom domains blocked." to "कोई कस्टम डोमेन ब्लॉक नहीं किया गया.",
    "No data leaves device" to "कोई डेटा डिवाइस नहीं छोड़ता",
    "No new notifications" to "कोई नए संदेश नहीं",
    "No recent analysis to view" to "देखने के लिए कोई हालिया विश्लेषण नहीं",
    "No recent scans" to "कोई हालिया स्कैन नहीं",
    "No security threats were detected. The QR code leads to a verified safe destination." to "कोई सुरक्षा ख़तरा नहीं पाया गया. क्यूआर कोड एक सत्यापित सुरक्षित गंतव्य की ओर ले जाता है।",
    "No threats detected" to "कोई खतरा नहीं मिला",
    "None" to "कोई नहीं",
    "Not a valid URL" to "मान्य यूआरएल नहीं",
    "Not found in 52 local offline threat databases." to "52 स्थानीय ऑफ़लाइन खतरा डेटाबेस में नहीं मिला।",
    "Not the official PayPal domain (paypal.com)" to "आधिकारिक PayPal डोमेन नहीं (paypal.com)",
    "Notifications" to "सूचनाएं",
    "Obfuscated JavaScript" to "अस्पष्ट जावास्क्रिप्ट",
    "Obfuscated Script" to "अस्पष्ट स्क्रिप्ट",
    "Official LinkedIn domain" to "आधिकारिक लिंक्डइन डोमेन",
    "Official postal services use their primary domain (auspost.com.au) for all tracking. Verify by visiting the official website directly." to "आधिकारिक डाक सेवाएँ सभी ट्रैकिंग के लिए अपने प्राथमिक डोमेन (auspost.com.au) का उपयोग करती हैं। सीधे आधिकारिक वेबसाइट पर जाकर सत्यापित करें।",
    "Offline" to "ऑफलाइन",
    "Offline Core v2.4" to "ऑफ़लाइन कोर v2.4",
    "Offline Engine V.2.4" to "ऑफ़लाइन इंजन V.2.4",
    "Offline Guarantee:" to "ऑफ़लाइन गारंटी:",
    "Offline Mode" to "ऑफ़लाइन मोड",
    "Offline Mode Active" to "ऑफ़लाइन मोड सक्रिय",
    "Offline Privacy" to "ऑफ़लाइन गोपनीयता",
    "Offline Protection" to "ऑफ़लाइन सुरक्षा",
    "Offline Ready" to "ऑफ़लाइन तैयार",
    "Offline Security" to "ऑफ़लाइन सुरक्षा",
    "Offline-First Architecture" to "ऑफ़लाइन-प्रथम वास्तुकला",
    "On-Device DB" to "ऑन-डिवाइस डीबी",
    "On-Device Database" to "ऑन-डिवाइस डेटाबेस",
    "Onboarding" to "ज्ञानप्राप्ति",
    "Only blocks known malicious URLs from the threat database. Minimal false positives, but may miss novel attacks." to "केवल ख़तरे वाले डेटाबेस से ज्ञात दुर्भावनापूर्ण URL को ब्लॉक करता है। न्यूनतम झूठी सकारात्मकता, लेकिन नए हमलों की संभावना कम हो सकती है।",
    "Open Safely (Sandbox)" to "सुरक्षित रूप से खोलें (सैंडबॉक्स)",
    "Open Source Licenses" to "ओपन सोर्स लाइसेंस",
    "Opening PhishTank..." to "फ़िशटैंक खुल रहा है...",
    "Opening URL in new tab" to "नए टैब में यूआरएल खुल रहा है",
    "Opening email client..." to "ईमेल क्लाइंट खोला जा रहा है...",
    "Optimised for desktop environments. Scans are processed in under 5ms using native Kotlin Multiplatform binaries." to "डेस्कटॉप वातावरण के लिए अनुकूलित. देशी कोटलिन मल्टीप्लेटफ़ॉर्म बायनेरिज़ का उपयोग करके स्कैन को 5ms से कम में संसाधित किया जाता है।",
    "Overview" to "सिंहावलोकन",
    "PASS" to "उत्तीर्ण",
    "PDF format. Best for sharing with stakeholders." to "पीडीएफ प्रारूप. हितधारकों के साथ साझा करने के लिए सर्वोत्तम.",
    "PDF report ready for download" to "पीडीएफ रिपोर्ट डाउनलोड के लिए तैयार है",
    "PHISH" to "फिश",
    "PHISHING" to "फ़िशिंग",
    "PROCEED WITH CAUTION" to "सावधानी के साथ आगे बढ़ना",
    "Paranoia" to "पागलपन",
    "Paranoia Mode" to "व्यामोह मोड",
    "Paste URL" to "यूआरएल चिपकाएँ",
    "Paste URL to Analyze" to "विश्लेषण करने के लिए URL चिपकाएँ",
    "PayPal Security" to "पेपैल सुरक्षा",
    "Permissive" to "अनुमोदक",
    "Phishing" to "फ़िशिंग",
    "Phishing Attempt" to "फ़िशिंग प्रयास",
    "Phishing Detection Sensitivity" to "फ़िशिंग जांच संवेदनशीलता",
    "Phishing Engine" to "फ़िशिंग इंजन",
    "Phishing Report: {url}" to "फ़िशिंग रिपोर्ट: {url}",
    "Phishing detection is running normally" to "फ़िशिंग का पता लगाना सामान्य रूप से चल रहा है",
    "Play Again" to "फिर से चालू करें",
    "Play Now" to "अब खेलते हैं",
    "Play sound when threat detected" to "खतरे का पता चलने पर ध्वनि बजाएं",
    "Please drop an image file" to "कृपया एक छवि फ़ाइल छोड़ें",
    "Please enter a URL" to "कृपया एक यूआरएल दर्ज करें",
    "Please enter a domain" to "कृपया एक डोमेन दर्ज करें",
    "Please enter a valid domain" to "कृपया एक मान्य डोमेन दर्ज करें",
    "Please select an image" to "कृपया एक छवि चुनें",
    "Point your camera at a QR code to detect" to "पता लगाने के लिए अपने कैमरे को क्यूआर कोड पर इंगित करें",
    "Points" to "अंक",
    "Press Cmd/Ctrl+V again to paste" to "पेस्ट करने के लिए फिर से Cmd/Ctrl+V दबाएँ",
    "Privacy Controls" to "गोपनीयता नियंत्रण",
    "Privacy Policy" to "गोपनीयता नीति",
    "Privacy Settings" to "गोपनीय सेटिंग",
    "Privacy policy: 100% offline, zero data collection" to "गोपनीयता नीति: 100% ऑफ़लाइन, शून्य डेटा संग्रह",
    "Proceed with Caution" to "सावधानी के साथ आगे बढ़ना",
    "Processing Env" to "प्रसंस्करण पर्यावरण",
    "Processing image..." to "छवि संसाधित हो रही है...",
    "Profile" to "प्रोफ़ाइल",
    "Profile updated successfully!" to "प्रोफ़ाइल सफलतापूर्वक अपडेट की गई!",
    "Punycode Domain" to "पुनीकोड ​​डोमेन",
    "QR Code Detected!" to "QR कोड का पता चला!",
    "QR Code Scan" to "क्यूआर कोड स्कैन",
    "QR Code detected!" to "QR कोड का पता चला!",
    "Mehr Guard" to "[[ब्रांड]]",
    "Mehr Guard - Beat the Bot" to "[[ब्रांड]] - बॉट को हराएं",
    "Mehr Guard - Dashboard" to "[[ब्रांड]] - डैशबोर्ड",
    "Mehr Guard - Offline Privacy Onboarding" to "[[ब्रांड]] - ऑफ़लाइन गोपनीयता ऑनबोर्डिंग",
    "Mehr Guard - Scan Dashboard" to "[[ब्रांड]] - डैशबोर्ड को स्कैन करें",
    "Mehr Guard - Scan Result" to "[[ब्रांड]] - स्कैन परिणाम",
    "Mehr Guard - Trust Centre" to "[[ब्रांड]] - ट्रस्ट सेंटर",
    "Mehr Guard Logo" to "[[ब्रांड लोगो",
    "Mehr Guard Results" to "[[ब्रांड]] परिणाम",
    "Mehr Guard Scan Result" to "[[ब्रांड]] स्कैन परिणाम",
    "Mehr Guard Security Audit" to "[[ब्रांड]] सुरक्षा ऑडिट",
    "Mehr Guard Threat Analysis Report" to "[[ब्रांड]] खतरा विश्लेषण रिपोर्ट",
    "Mehr Guard Threat Report" to "[[ब्रांड]] धमकी रिपोर्ट",
    "Mehr Guard Verdict: {verdict}" to "[[ब्रांड]] फैसला: {verdict}",
    "Mehr Guard analyses potential threats directly on your hardware. Experience" to "[[ब्रांड]] सीधे आपके हार्डवेयर पर संभावित खतरों का विश्लेषण करता है। अनुभव",
    "Mehr Guard explains" to "[[ब्रांड]] बताते हैं",
    "Mehr Guard needs camera access to scan QR codes in real-time." to "[[ब्रांड]] को वास्तविक समय में क्यूआर कोड स्कैन करने के लिए कैमरे की पहुंच की आवश्यकता है।",
    "Mehr Guard processes every scan within a secure, isolated local sandbox. We prioritize explainable security with zero cloud telemetry for image analysis." to "[[ब्रांड]] प्रत्येक स्कैन को एक सुरक्षित, पृथक स्थानीय सैंडबॉक्स में संसाधित करता है। हम छवि विश्लेषण के लिए शून्य क्लाउड टेलीमेट्री के साथ व्याख्या योग्य सुरक्षा को प्राथमिकता देते हैं।",
    "Mehr Guard strictly disables all outgoing telemetry. Your scan results, URL history, and image hashes never leave your device." to "[[ब्रांड]] सभी आउटगोइंग टेलीमेट्री को सख्ती से अक्षम कर देता है। आपके स्कैन परिणाम, यूआरएल इतिहास और छवि हैश आपके डिवाइस को कभी नहीं छोड़ते हैं।",
    "Mehr Guard uses local heuristic analysis engines. No image data, URL strings, or metadata leaves this device during scanning. Your privacy is mathematically guaranteed." to "[[ब्रांड]] स्थानीय अनुमानी विश्लेषण इंजन का उपयोग करता है। स्कैनिंग के दौरान कोई छवि डेटा, यूआरएल स्ट्रिंग या मेटाडेटा इस डिवाइस को नहीं छोड़ता है। आपकी गोपनीयता की गणितीय गारंटी है।",
    "Mehr Guard works 100% offline! All analysis is done locally on your device. No internet connection required." to "[[ब्रांड]] 100% ऑफ़लाइन काम करता है! सभी विश्लेषण आपके डिवाइस पर स्थानीय रूप से किया जाता है। इंटरनेट कनेक्शन की आवश्यकता नहीं.",
    "Mehr Guard | Premium Web Scanner" to "[[ब्रांड]] | प्रीमियम वेब स्कैनर",
    "Mehr Guard Bot" to "क्यूआर-शील्ड बॉट",
    "Quarantine in Sandbox" to "सैंडबॉक्स में संगरोध",
    "Quarantined in secure sandbox for analysis" to "विश्लेषण के लिए सुरक्षित सैंडबॉक्स में क्वारंटाइन किया गया",
    "READY" to "तैयार",
    "Randomly generated domains are often temporary phishing sites" to "बेतरतीब ढंग से उत्पन्न डोमेन अक्सर अस्थायी फ़िशिंग साइट होते हैं",
    "Raw Image Buffer" to "कच्ची छवि बफ़र",
    "Read Only" to "केवल पढ़ने के लिए",
    "Real-Time Scanning" to "वास्तविक समय स्कैनिंग",
    "Real-time scanning" to "वास्तविक समय स्कैनिंग",
    "Recent Scans" to "हालिया स्कैन",
    "Recommended Actions" to "अनुशंसित कार्रवाइयां",
    "Refresh Page" to "पृष्ठ ताज़ा करें",
    "Removed {domain} from {list}" to "{list} से {domain} हटा दिया गया",
    "Removing or changing the suspicious pattern would reduce the overall risk score." to "संदिग्ध पैटर्न को हटाने या बदलने से समग्र जोखिम स्कोर कम हो जाएगा।",
    "Report Export - Mehr Guard" to "रिपोर्ट निर्यात - [[ब्रांड]]",
    "Report Generation" to "रिपोर्ट पीढ़ी",
    "Report Incorrect Verdict" to "ग़लत निर्णय की रिपोर्ट करें",
    "Report Phishing" to "फ़िशिंग की रिपोर्ट करना",
    "Report URL copied to clipboard" to "रिपोर्ट यूआरएल क्लिपबोर्ड पर कॉपी किया गया",
    "Report copied to clipboard" to "रिपोर्ट क्लिपबोर्ड पर कॉपी की गई",
    "Report if this verdict is wrong" to "अगर यह फैसला गलत है तो रिपोर्ट करें",
    "Report shared" to "रिपोर्ट साझा की गई",
    "Report shared successfully!" to "रिपोर्ट सफलतापूर्वक साझा की गई!",
    "Reported: {timestamp}" to "रिपोर्ट: {timestamp}",
    "Reports" to "रिपोर्टों",
    "Reset Defaults" to "डिफ़ॉल्ट रीसेट करें",
    "Reset all Trust Centre settings to default?" to "सभी ट्रस्ट सेंटर सेटिंग्स को डिफ़ॉल्ट पर रीसेट करें?",
    "Reset all settings to default" to "सभी सेटिंग्स को डिफ़ॉल्ट पर रीसेट करें",
    "Response" to "प्रतिक्रिया",
    "Result" to "परिणाम",
    "Result # {id}" to "परिणाम # {id}",
    "Result #8291-A" to "परिणाम #8291-ए",
    "Result copied to clipboard!" to "परिणाम क्लिपबोर्ड पर कॉपी किया गया!",
    "Results Dashboard" to "परिणाम डैशबोर्ड",
    "Return to Dashboard" to "डैशबोर्ड पर लौटें",
    "Risk Assessment" to "जोखिम आकलन",
    "Risk Score" to "जोखिम स्कोर",
    "Risk Score: {score}/100" to "जोखिम स्कोर: {score}/100",
    "Risk impact:" to "जोखिम प्रभाव:",
    "Round" to "गोल",
    "SAFE" to "सुरक्षित",
    "SAFE TO VISIT" to "यात्रा के लिए सुरक्षित",
    "SMS from unknown number impersonating AusPost" to "AusPost का प्रतिरूपण करते हुए अज्ञात नंबर से एसएमएस",
    "SSL Certificate Issues" to "एसएसएल प्रमाणपत्र मुद्दे",
    "SUSPICIOUS" to "संदिग्ध",
    "SUSPICIOUS ACTIVITY" to "संदिग्ध गतिविधि",
    "Safe" to "सुरक्षित",
    "Safe Scans" to "सुरक्षित स्कैन",
    "Safe to Visit" to "यात्रा के लिए सुरक्षित",
    "Safe vs Risky QR Codes" to "सुरक्षित बनाम जोखिम भरा क्यूआर कोड",
    "Safety Score" to "सुरक्षा स्कोर",
    "Save & Continue" to "सहेजें जारी रखें",
    "Scan" to "स्कैन",
    "Scan # {id}" to "स्कैन # {id}",
    "Scan #8021-AF" to "#8021-एएफ स्कैन करें",
    "Scan Another" to "दूसरे को स्कैन करें",
    "Scan Complete" to "स्कैन पूर्ण",
    "Scan History" to "इतिहास स्कैन करें",
    "Scan Meta" to "मेटा स्कैन करें",
    "Scan Monitor" to "स्कैन मॉनिटर",
    "Scan New QR" to "नया QR स्कैन करें",
    "Scan QR" to "QR स्कैन करें",
    "Scan QR Code" to "स्कैन क्यू आर कोड",
    "Scan QR codes as they're detected" to "क्यूआर कोड का पता चलने पर उन्हें स्कैन करें",
    "Scan Time" to "स्कैन समय",
    "Scan URLs Safely" to "यूआरएल को सुरक्षित रूप से स्कैन करें",
    "Scan history cleared" to "स्कैन इतिहास साफ़ किया गया",
    "Scan this QR code with Mehr Guard to see malicious URL detection:" to "दुर्भावनापूर्ण URL पहचान देखने के लिए इस QR कोड को Mehr Guard से स्कैन करें:",
    "Scanned with Mehr Guard - {url}" to "[[ब्रांड]] - {url} के साथ स्कैन किया गया",
    "Scanner Dashboard" to "स्कैनर डैशबोर्ड",
    "Scanning..." to "स्कैन किया जा रहा है...",
    "Scans" to "स्कैन",
    "Scans for known malicious patterns and heuristic mismatches. Blocks homoglyph attacks and redirect chains. Low false positive rate expected." to "ज्ञात दुर्भावनापूर्ण पैटर्न और अनुमानी बेमेल के लिए स्कैन। होमोग्लिफ़ हमलों को रोकता है और श्रृंखलाओं को पुनर्निर्देशित करता है। कम झूठी सकारात्मक दर अपेक्षित।",
    "Secure Environment" to "सुरक्षित वातावरण",
    "Secure. Offline." to "सुरक्षित। ऑफ़लाइन.",
    "Security" to "सुरक्षा",
    "Security Analyst" to "सुरक्षा विश्लेषक",
    "Security Audit: PASS" to "सुरक्षा ऑडिट: पास",
    "Security Engine Active" to "सुरक्षा इंजन सक्रिय",
    "Security Heuristics" to "सुरक्षा अनुमान",
    "Security Settings" to "सुरक्षा सेटिंग्स",
    "Security audit report downloaded" to "सुरक्षा ऑडिट रिपोर्ट डाउनलोड की गई",
    "See Results" to "परिणाम देखें",
    "See the difference instantly:" to "तुरंत अंतर देखें:",
    "Sensitivity Level" to "संवेदनशीलता स्तर",
    "Sensitivity set to {level}" to "संवेदनशीलता {level} पर सेट की गई",
    "Session ID: #GAME-" to "सत्र आईडी: #गेम-",
    "Settings" to "सेटिंग्स",
    "Settings are saved automatically and sync across sessions." to "सेटिंग्स स्वचालित रूप से सहेजी जाती हैं और सभी सत्रों में समन्वयित होती हैं।",
    "Settings reset to default" to "सेटिंग्स डिफ़ॉल्ट पर रीसेट हो गईं",
    "Settings reset to defaults" to "सेटिंग्स डिफ़ॉल्ट पर रीसेट हो गईं",
    "Settings saved! Your data stays on-device." to "सेटिंग्स को सहेजा गया! आपका डेटा डिवाइस पर रहता है.",
    "Share" to "शेयर करना",
    "Share Report" to "रिपोर्ट साझा करें",
    "Share detection stats to improve ML." to "एमएल को बेहतर बनाने के लिए डिटेक्शन आँकड़े साझा करें।",
    "Shared successfully!" to "सफलतापूर्वक साझा किया गया!",
    "Sharing not supported" to "साझाकरण समर्थित नहीं है",
    "Short URLs hide the actual destination. Prize claims from unknown numbers are almost always scams." to "छोटे URL वास्तविक गंतव्य को छुपाते हैं। अज्ञात नंबरों से पुरस्कार के दावे लगभग हमेशा घोटाले होते हैं।",
    "Shortened URL hides true destination" to "छोटा किया गया यूआरएल सही गंतव्य को छुपाता है",
    "Show Confidence Score" to "कॉन्फिडेंस स्कोर दिखाएं",
    "Show visual alerts for threats" to "खतरों के लिए विज़ुअल अलर्ट दिखाएं",
    "Sign in to your GitHub account to access your repositories." to "अपनी रिपॉजिटरी तक पहुँचने के लिए अपने GitHub खाते में साइन इन करें।",
    "Signatures" to "हस्ताक्षर",
    "Skip" to "छोडना",
    "Some features may not work in your browser." to "हो सकता है कि कुछ सुविधाएं आपके ब्राउज़र में काम न करें.",
    "Some minor security concerns were identified. The link appears mostly safe but review recommended." to "कुछ छोटी सुरक्षा चिंताओं की पहचान की गई। लिंक अधिकतर सुरक्षित प्रतीत होता है लेकिन समीक्षा अनुशंसित है।",
    "Some suspicious indicators detected. Verify the source before entering sensitive information." to "कुछ संदिग्ध संकेतकों का पता चला। संवेदनशील जानकारी दर्ज करने से पहले स्रोत को सत्यापित करें।",
    "Sound Alerts" to "ध्वनि अलर्ट",
    "Sound alerts" to "ध्वनि अलर्ट",
    "Source" to "स्रोत",
    "Standard Gmail URL structure" to "मानक जीमेल यूआरएल संरचना",
    "Standard Google Docs URL format" to "मानक Google डॉक्स URL प्रारूप",
    "Standard profile URL structure" to "मानक प्रोफ़ाइल यूआरएल संरचना",
    "Status" to "स्थिति",
    "Streak:" to "धारी:",
    "Strict" to "कठोर",
    "Strict Offline Guarantee" to "सख्त ऑफ़लाइन गारंटी",
    "Strict Offline Mode" to "सख्त ऑफ़लाइन मोड",
    "Strict Offline Mode disabled" to "सख्त ऑफ़लाइन मोड अक्षम किया गया",
    "Strict Offline Mode enabled" to "सख्त ऑफ़लाइन मोड सक्षम",
    "Subdomain \"signin\" used for deception" to "धोखे के लिए उपडोमेन \"साइनइन\" का उपयोग किया जाता है",
    "Subdomain of google.com" to "google.com का उपडोमेन",
    "Subdomain of google.com (trusted)" to "google.com का उपडोमेन (विश्वसनीय)",
    "Submitted via Mehr Guard" to "[[ब्रांड]] के माध्यम से सबमिट किया गया",
    "Success!" to "सफलता!",
    "Support" to "सहायता",
    "Suspicious" to "संदिग्ध",
    "Suspicious Redirect Chain" to "संदिग्ध पुनर्निर्देशन श्रृंखला",
    "Suspicious TLD" to "संदिग्ध टीएलडी",
    "Suspicious TLD (.tk)" to "संदिग्ध टीएलडी (.tk)",
    "Switch Language: English/Deutsch" to "स्विच भाषा: अंग्रेजी/जर्मन",
    "Switched to {mode} mode" to "{mode} मोड पर स्विच किया गया",
    "System Health" to "सिस्टम स्वास्थ्य",
    "System Secure" to "सिस्टम सुरक्षित",
    "System Status" to "सिस्टम स्थिति",
    "Systems Operational" to "सिस्टम परिचालन",
    "TLD" to "टीएलडी",
    "Target IP is located in a high-risk ASN." to "लक्ष्य आईपी उच्च जोखिम वाले एएसएन में स्थित है।",
    "Target URL" to "लक्ष्य यूआरएल",
    "Technical Indicators" to "तकनीकी संकेतक",
    "Technical Indicators:" to "तकनीकी संकेतक:",
    "Terms" to "शर्तें",
    "Test QR Code" to "QR कोड का परीक्षण करें",
    "Thank you! Feedback recorded: Should be {verdict}" to "धन्यवाद! फीडबैक रिकॉर्ड किया गया: {verdict} होना चाहिए",
    "The Kotlin/JS analysis engine is still loading or failed to initialize." to "कोटलिन/जेएस विश्लेषण इंजन अभी भी लोड हो रहा है या प्रारंभ करने में विफल रहा है।",
    "The bot was faster this time. Try again!" to "इस बार बॉट तेज़ था। पुनः प्रयास करें!",
    "The destination URL employs" to "गंतव्य URL कार्यरत है",
    "The domain uses the Cyrillic 'а' (U+0430) instead of Latin 'a' (U+0061)." to "डोमेन लैटिन 'ए' (यू+0061) के बजाय सिरिलिक 'ए' (यू+0430) का उपयोग करता है।",
    "The domain uses the Cyrillic 'а' (U+0430) instead of Latin 'a' (U+0061). This technique is commonly used to trick users into believing they are visiting a legitimate service." to "डोमेन लैटिन 'ए' (यू+0061) के बजाय सिरिलिक 'ए' (यू+0430) का उपयोग करता है। इस तकनीक का उपयोग आमतौर पर उपयोगकर्ताओं को यह विश्वास दिलाने के लिए किया जाता है कि वे किसी वैध सेवा पर जा रहे हैं।",
    "The entire threat signature database (100,000+ patterns) is stored locally for millisecond lookups without any network requests." to "संपूर्ण खतरा हस्ताक्षर डेटाबेस (100,000+ पैटर्न) बिना किसी नेटवर्क अनुरोध के मिलीसेकंड लुकअप के लिए स्थानीय रूप से संग्रहीत किया जाता है।",
    "The entire threat signature database is downloaded to your device for millisecond lookups." to "मिलीसेकंड लुकअप के लिए संपूर्ण खतरा हस्ताक्षर डेटाबेस आपके डिवाइस पर डाउनलोड किया जाता है।",
    "The image doesn\\'t contain a recognizable QR code, or it may be damaged." to "छवि में पहचानने योग्य QR कोड नहीं है, अन्यथा यह क्षतिग्रस्त हो सकती है।",
    "The input doesn\\'t appear to be a valid URL." to "ऐसा प्रतीत होता है कि इनपुट एक वैध यूआरएल नहीं है।",
    "The number 1 and lowercase L look identical in many fonts. Always verify paypal.com directly." to "संख्या 1 और लोअरकेस एल कई फ़ॉन्ट में समान दिखते हैं। हमेशा सीधे paypal.com को सत्यापित करें।",
    "The pattern matches known phishing characteristics" to "पैटर्न ज्ञात फ़िशिंग विशेषताओं से मेल खाता है",
    "The scanned QR code contains malicious indicators associated with phishing and credential harvesting. Do not proceed to the target URL." to "स्कैन किए गए क्यूआर कोड में फ़िशिंग और क्रेडेंशियल हार्वेस्टिंग से जुड़े दुर्भावनापूर्ण संकेतक होते हैं। लक्ष्य URL पर आगे न बढ़ें.",
    "The scanned QR code shows suspicious patterns that may indicate potential security risks. Proceed with caution." to "स्कैन किया गया क्यूआर कोड संदिग्ध पैटर्न दिखाता है जो संभावित सुरक्षा जोखिमों का संकेत दे सकता है। सावधानी के साथ आगे बढ़ना।",
    "Think you can outsmart our AI? Try to craft a phishing URL that fools the detector!" to "क्या आपको लगता है कि आप हमारे AI को मात दे सकते हैं? एक फ़िशिंग यूआरएल तैयार करने का प्रयास करें जो डिटेक्टर को मूर्ख बना दे!",
    "This URL passed all {count} security checks" to "इस यूआरएल ने सभी {count} सुरक्षा जांच पास कर ली है",
    "This URL triggered a security check" to "इस यूआरएल ने एक सुरक्षा जांच शुरू कर दी",
    "This URL was flagged by Mehr Guard\\'s offline phishing detection engine." to "इस URL को Mehr Guard\\ के ऑफ़लाइन फ़िशिंग डिटेक्शन इंजन द्वारा फ़्लैग किया गया था।",
    "This image was analysed locally on your device. No data was sent to the cloud for this verdict." to "इस छवि का आपके डिवाइस पर स्थानीय रूप से विश्लेषण किया गया था। इस फैसले के लिए क्लाउड पर कोई डेटा नहीं भेजा गया था।",
    "This is a Google subdomain - check if it\\'s the legitimate Gmail service." to "यह एक Google उपडोमेन है - जांचें कि क्या यह वैध Gmail सेवा है।",
    "This is a security feature — your URLs never leave your device." to "यह एक सुरक्षा सुविधा है - आपके यूआरएल आपके डिवाइस को कभी नहीं छोड़ते हैं।",
    "This is a well-established software company domain." to "यह एक सुस्थापित सॉफ़्टवेयर कंपनी डोमेन है।",
    "This is the official LinkedIn domain for professional networking." to "यह पेशेवर नेटवर्किंग के लिए आधिकारिक लिंक्डइन डोमेन है।",
    "This may happen if: • You're using a very old browser • JavaScript is disabled • The page didn't fully load Try refreshing the page. If the issue persists, try Chrome, Firefox, or Safari." to "ऐसा तब हो सकता है यदि: • आप बहुत पुराने ब्राउज़र का उपयोग कर रहे हैं • जावास्क्रिप्ट अक्षम है • पृष्ठ पूरी तरह से लोड नहीं हुआ है पृष्ठ को ताज़ा करने का प्रयास करें। यदि समस्या बनी रहती है, तो Chrome, Firefox, या Safari आज़माएँ।",
    "This was actually {label}." to "यह वास्तव में {label} था।",
    "This was {label}." to "यह {label} था।",
    "Threat Alerts" to "ख़तरे की चेतावनी",
    "Threat Analysis" to "खतरा विश्लेषण",
    "Threat Analysis Report" to "खतरा विश्लेषण रिपोर्ट",
    "Threat Confidence" to "ख़तरा आत्मविश्वास",
    "Threat Database" to "ख़तरा डेटाबेस",
    "Threat Detected" to "खतरे का पता चल गया है",
    "Threat Verdict" to "धमकी भरा फैसला",
    "Threat alerts" to "ख़तरे की चेतावनी",
    "Threat blocked and reported" to "धमकी को अवरुद्ध कर दिया गया और रिपोर्ट की गई",
    "Threat database is up to date" to "खतरा डेटाबेस अद्यतित है",
    "Threat signatures updated to v2.4.1" to "ख़तरे वाले हस्ताक्षरों को v2.4.1 में अद्यतन किया गया",
    "Threats" to "धमकियाँ",
    "Time" to "समय",
    "Tips for better scanning: • Ensure good lighting • Hold the camera steady • Fill the frame with the QR code • Avoid glare or reflections • Try uploading a clearer image" to "बेहतर स्कैनिंग के लिए युक्तियाँ: • अच्छी रोशनी सुनिश्चित करें • कैमरे को स्थिर रखें • फ्रेम को क्यूआर कोड से भरें • चमक या प्रतिबिंब से बचें • एक स्पष्ट छवि अपलोड करने का प्रयास करें",
    "Today, 04:00 AM" to "आज प्रातः 04:00 बजे",
    "Today, 14:32:05" to "आज दिनांक 14:32:05",
    "Today, {time}" to "आज, {time}",
    "Toggle Judge Mode" to "जज मोड टॉगल करें",
    "Toggle Language" to "भाषा टॉगल करें",
    "Toggle Theme" to "थीम टॉगल करें",
    "Toggle light/dark mode" to "लाइट/डार्क मोड टॉगल करें",
    "Toggle menu" to "मेनू टॉगल करें",
    "Toggle theme" to "थीम टॉगल करें",
    "Top 100 Alexa Rank - whitelisted" to "शीर्ष 100 एलेक्सा रैंक - श्वेतसूचीबद्ध",
    "Top 1k Alexa Rank whitelisted offline." to "शीर्ष 1k एलेक्सा रैंक ऑफ़लाइन श्वेतसूची में।",
    "Top Analysis Factors" to "शीर्ष विश्लेषण कारक",
    "Torch" to "मशाल",
    "Torch error" to "टॉर्च त्रुटि",
    "Torch not available" to "टॉर्च उपलब्ध नहीं है",
    "Torch off" to "टॉर्च बंद",
    "Torch on" to "टॉर्च चालू",
    "Training" to "प्रशिक्षण",
    "Training Centre" to "प्रशिक्षण केंद्र",
    "Trust Centre" to "ट्रस्ट सेंटर",
    "Try Again" to "पुनः प्रयास करें",
    "Try It Now!" to "अब इसे आजमाओ!",
    "Typosquatting" to "टाइपोस्क्वैटिंग",
    "Typosquatting Detected" to "टाइपिंग का पता लगाया गया",
    "Typosquatting pattern detected" to "टाइपोस्क्वैटिंग पैटर्न का पता चला",
    "UNKNOWN" to "अज्ञात",
    "URL" to "यूआरएल",
    "URL Shortener" to "यूआरएल शॉर्टनर",
    "URL Shortener Detected" to "यूआरएल शॉर्टनर का पता चला",
    "URL contains Cyrillic, Greek, or other lookalike Unicode characters" to "URL में सिरिलिक, ग्रीक या अन्य समान यूनिकोड वर्ण शामिल हैं",
    "URL contains another URL in query parameters" to "यूआरएल में क्वेरी पैरामीटर में एक और यूआरएल शामिल है",
    "URL copied to clipboard!" to "यूआरएल क्लिपबोर्ड पर कॉपी किया गया!",
    "URL exceeds 100 characters" to "यूआरएल 100 अक्षरों से अधिक है",
    "URL parsing (please update your browser)" to "यूआरएल पार्सिंग (कृपया अपना ब्राउज़र अपडेट करें)",
    "URL pasted - press Enter to analyze" to "URL चिपकाया गया - विश्लेषण करने के लिए Enter दबाएँ",
    "URL path contains /login, /signin, /verify, /secure, /account" to "यूआरएल पथ में /लॉगिन, /साइनइन, /सत्यापित, /सुरक्षित, /खाता शामिल है",
    "URL to analyze" to "विश्लेषण करने के लिए यूआरएल",
    "URL uses raw IP address instead of domain name" to "यूआरएल डोमेन नाम के बजाय कच्चे आईपी पते का उपयोग करता है",
    "URL:" to "यूआरएल:",
    "URL: {url}" to "यूआरएल: {url}",
    "URL: {url}\\nVerdict: {verdict}\\nConfidence: {confidence}%" to "यूआरएल: {url}\\nनिर्णय: {verdict}\\nआत्मविश्वास: {confidence}%",
    "URLs are risky!" to "यूआरएल जोखिम भरे हैं!",
    "Unable to determine verdict. Please try again." to "निर्णय निर्धारित करने में असमर्थ. कृपया पुन: प्रयास करें।",
    "Unknown" to "अज्ञात",
    "Unknown URL" to "अज्ञात यूआरएल",
    "Unknown Verdict" to "अज्ञात फैसला",
    "Unknown sender number" to "अज्ञात प्रेषक संख्या",
    "Unsolicited prize notification" to "अनचाही पुरस्कार अधिसूचना",
    "Upload" to "अपलोड करें",
    "Upload Image" to "तस्विर अपलोड करना",
    "Upload Image Instead" to "इसके बजाय छवि अपलोड करें",
    "Urgency tactics in message" to "संदेश में तात्कालिक रणनीति",
    "Use condensed layout for results" to "परिणामों के लिए संक्षिप्त लेआउट का उपयोग करें",
    "Users may not notice subtle character swaps like \"1\" for \"l\" or \"0\" for \"o\"" to "उपयोगकर्ताओं को \"एल\" के लिए \"1\" या \"ओ\" के लिए \"0\" जैसे सूक्ष्म वर्ण स्वैप नज़र नहीं आ सकते हैं",
    "Uses bit.ly, t.co, tinyurl, or similar shortening service" to "bit.ly, t.co, tinyurl, या इसी तरह की शॉर्टिंग सेवा का उपयोग करता है",
    "Uses high-risk TLDs like .tk, .ml, .ga, .cf, .xyz" to ".tk, .ml, .ga, .cf, .xyz जैसे उच्च जोखिम वाले TLD का उपयोग करता है",
    "VERIFIED SAFE" to "सत्यापित सुरक्षित",
    "VS" to "बनाम",
    "VS MODE" to "वीएस मोड",
    "Valid Extended Validation certificate" to "वैध विस्तारित सत्यापन प्रमाण पत्र",
    "Valid Google certificate" to "मान्य Google प्रमाणपत्र",
    "Valid SSL Certificate" to "वैध एसएसएल प्रमाणपत्र",
    "Verdict" to "निर्णय",
    "Verdict: {verdict}" to "फैसला: {verdict}",
    "VerdictPhish" to "VerdictPish",
    "VerdictSafe" to "निर्णय सुरक्षित",
    "VerdictWarn" to "निर्णयचेतावनी",
    "Verified by Mehr Guard Enterprise" to "[[ब्रांड]] एंटरप्राइज़ द्वारा सत्यापित",
    "Verified by Mehr Guard Enterprise v{version}" to "[[ब्रांड]] एंटरप्राइज़ v{version} द्वारा सत्यापित",
    "Verified by local heuristics v2.4. No phishing patterns, obfuscated scripts, or blacklist matches found." to "स्थानीय अनुमान v2.4 द्वारा सत्यापित। कोई फ़िशिंग पैटर्न, अस्पष्ट स्क्रिप्ट या ब्लैकलिस्ट मिलान नहीं मिला।",
    "Verifying..." to "सत्यापन किया जा रहा है...",
    "Version" to "संस्करण",
    "Very High" to "बहुत ऊँचा",
    "View All" to "सभी को देखें",
    "View Full History" to "पूरा इतिहास देखें",
    "View Full Report" to "पूरी रिपोर्ट देखें",
    "View John Smith\\'s professional profile on LinkedIn." to "लिंक्डइन पर जॉन स्मिथ की पेशेवर प्रोफ़ाइल देखें।",
    "View Security Audit" to "सुरक्षा ऑडिट देखें",
    "View detailed analysis in dashboard" to "डैशबोर्ड में विस्तृत विश्लेषण देखें",
    "Visual Appearance (What user sees)" to "दृश्य उपस्थिति (उपयोगकर्ता क्या देखता है)",
    "WARN" to "चेतावनी देना",
    "Warning" to "चेतावनी",
    "We detect multiple attack types:" to "हम अनेक प्रकार के आक्रमणों का पता लगाते हैं:",
    "We strictly disable outgoing telemetry for scans. Scan results and image hashes remain local." to "हम स्कैन के लिए आउटगोइंग टेलीमेट्री को सख्ती से अक्षम करते हैं। स्कैन परिणाम और छवि हैश स्थानीय रहते हैं।",
    "Welcome to Jira - project tracking for agile teams." to "जिरा में आपका स्वागत है - चुस्त टीमों के लिए प्रोजेक्ट ट्रैकिंग।",
    "Welcome to Mehr Guard" to "[[ब्रांड]] में आपका स्वागत है",
    "What it checks:" to "यह क्या जाँचता है:",
    "Why it matters:" to "यह क्यों मायने रखती है:",
    "Why the bot flagged it" to "बॉट ने इसे क्यों चिह्नित किया?",
    "Why this verdict?" to "ये फैसला क्यों?",
    "Without other risk signals, login paths on safe domains would not increase score significantly." to "अन्य जोखिम संकेतों के बिना, सुरक्षित डोमेन पर लॉगिन पथ स्कोर में उल्लेखनीय वृद्धि नहीं करेंगे।",
    "Works 100% offline!" to "100% ऑफ़लाइन काम करता है!",
    "Workspace / Security / Reports" to "कार्यक्षेत्र/सुरक्षा/रिपोर्ट",
    "Would you like to report this URL?\\n\\nOptions:\\n1. PhishTank - Click OK to open submission page\\n2. Email - Click Cancel to compose email\\n\\nURL: {url}" to "क्या आप इस यूआरएल की रिपोर्ट करना चाहेंगे?\\n\\nविकल्प:\\n1. PhishTank - सबमिशन पेज खोलने के लिए ओके पर क्लिक करें\\n2. ईमेल - ईमेल लिखने के लिए रद्द करें पर क्लिक करें\\n\\nURL: {url}",
    "Wrong Verdict?" to "गलत फैसला?",
    "Wrong!" to "गलत!",
    "Yesterday" to "कल",
    "You" to "आप",
    "You can still use Mehr Guard by uploading images or pasting URLs directly." to "आप अभी भी चित्र अपलोड करके या सीधे यूआरएल चिपकाकर [[ब्रांड]] का उपयोग कर सकते हैं।",
    "You can still use Mehr Guard: • Upload QR code images • Paste URLs directly • Use the sample URLs provided" to "आप अभी भी [[ब्रांड]] का उपयोग कर सकते हैं: • क्यूआर कोड छवियां अपलोड करें • सीधे यूआरएल चिपकाएं • दिए गए नमूना यूआरएल का उपयोग करें",
    "You correctly identified this as {label}." to "आपने इसकी सही पहचान {label} के रूप में की है।",
    "You have 3 unread emails in your inbox." to "आपके इनबॉक्स में तीन अपठित ईमेल हैं।",
    "You identified the safe URL correctly." to "आपने सुरक्षित यूआरएल की सही पहचान की है.",
    "You spotted it correctly as {label}!" to "आपने इसे {label} के रूप में सही ढंग से देखा!",
    "You spotted the phishing URL correctly." to "आपने फ़िशिंग यूआरएल सही ढंग से पहचान लिया है।",
    "You're offline — analysis still works!" to "आप ऑफ़लाइन हैं - विश्लेषण अभी भी काम करता है!",
    "You're reporting that this verdict may be wrong:" to "आप रिपोर्ट कर रहे हैं कि यह निर्णय ग़लत हो सकता है:",
    "You\\'re Offline" to "आप ऑफ़लाइन हैं",
    "Your Score" to "तुम्हारे अंक",
    "Your browser doesn\\'t support camera access, or you\\'re on a device without a camera." to "आपका ब्राउज़र कैमरा एक्सेस का समर्थन नहीं करता है, या आप बिना कैमरे वाले डिवाइस पर हैं।",
    "Your data never leaves this device. All processing is local. No tracking, no uploads." to "आपका डेटा इस डिवाइस को कभी नहीं छोड़ता. सारी प्रोसेसिंग स्थानीय है. कोई ट्रैकिंग नहीं, कोई अपलोड नहीं.",
    "Your data stays on-device." to "आपका डेटा डिवाइस पर रहता है.",
    "\\nRisk Score:" to "\\nजोखिम स्कोर:",
    "a phishing attempt" to "एक फ़िशिंग प्रयास",
    "actually legitimate" to "वास्तव में वैध",
    "bit.ly shortener" to "बिट.ली शॉर्टनर",
    "characters often associated with phishing campaigns targeting financial institutions. The domain age is" to "पात्र अक्सर वित्तीय संस्थानों को लक्षित करने वाले फ़िशिंग अभियानों से जुड़े होते हैं। डोमेन की आयु है",
    "critical" to "गंभीर",
    "danger" to "खतरा",
    "for core services." to "मुख्य सेवाओं के लिए.",
    "high" to "उच्च",
    "homoglyph obfuscation" to "समरूपता अस्पष्टता",
    "in your browser." to "आपके ब्राउज़र में.",
    "just now" to "बस अब",
    "low" to "कम",
    "malicious" to "दुर्भावनापूर्ण",
    "medium" to "मध्यम",
    "offline" to "ऑफलाइन",
    "online" to "ऑनलाइन",
    "or click \"Upload\" to select a file" to "या किसी फ़ाइल का चयन करने के लिए \"अपलोड करें\" पर क्लिक करें",
    "phishing" to "फ़िशिंग",
    "risk-badge danger" to "जोखिम-बिल्ला खतरा",
    "risk-badge warning" to "जोखिम-बिल्ला चेतावनी",
    "risk-item-expanded severity-" to "जोखिम-वस्तु-विस्तारित गंभीरता-",
    "safe" to "सुरक्षित",
    "suspicious" to "संदिग्ध",
    "to analyze," to "विश्लेषण करने के लिए,",
    "to focus," to "ध्यान केंद्रित करने के लिए,",
    "to reset" to "रीसेट करना",
    "unknown" to "अज्ञात",
    "v2.4.1 •" to "v2.4.1 •",
    "warning" to "चेतावनी",
    "without compromising data privacy." to "डेटा गोपनीयता से समझौता किए बिना.",
    "zero-latency phishing detection" to "शून्य-विलंबता फ़िशिंग का पता लगाना",
    "{date}, {time}" to "{date}, {time}",
    "{days} day ago" to "{days} दिन पहले",
    "{days} days ago" to "{days} दिन पहले",
    "{hours} hour ago" to "{hours} घंटा पहले",
    "{hours} hours ago" to "{hours} घंटे पहले",
    "{label} disabled" to "{label} अक्षम",
    "{label} enabled" to "{label} सक्षम",
    "{level} Confidence" to "{level} आत्मविश्वास",
    "{minutes} minute ago" to "{minutes} मिनट पहले",
    "{minutes} minutes ago" to "{minutes} मिनट पहले",
    "{months} month ago" to "{months} महीने पहले",
    "{months} months ago" to "{months} महीने पहले",
    "{points} pts" to "{points} अंक",
    "{title}: {summary}" to "{title}: {summary}",
    "{weeks} week ago" to "{weeks} सप्ताह पहले",
    "{weeks} weeks ago" to "{weeks} सप्ताह पहले",
    "© 2024 Mehr Guard Security Inc. All rights reserved." to "© 2024 [[ब्रांड]] सिक्योरिटी इंक. सर्वाधिकार सुरक्षित।",
    "हिन्दी" to "हिन्दी",
    "⌨️ Tip: Press" to "⌨️ टिप: दबाएँ",
    "⚠ Try Phishing URL" to "⚠ फ़िशिंग URL आज़माएँ",
    "✅ No data leaves your device" to "✅ कोई भी डेटा आपके डिवाइस को नहीं छोड़ता",
    "✅ Same engine as mobile apps" to "✅ मोबाइल ऐप्स जैसा ही इंजन",
    "✅ Works without internet" to "✅ बिना इंटरनेट के काम करता है",
    "✓ No brand impersonation" to "✓ कोई ब्रांड प्रतिरूपण नहीं",
    "✓ No homograph attacks" to "✓ कोई होमोग्राफ़ हमला नहीं",
    "✓ No suspicious patterns" to "✓ कोई संदिग्ध पैटर्न नहीं",
    "✓ Safe TLD" to "✓ सुरक्षित टीएलडी",
    "✓ Try Safe URL" to "✓ सुरक्षित यूआरएल आज़माएं",
    "日本語" to "ठीक है",
    "简体中文" to "मुझे यह पसंद है",
    "🌐 Homograph attacks (Cyrillic chars)" to "🌐 होमोग्राफ़ हमले (सिरिलिक वर्ण)",
    "🎉 You Win!" to "🎉आप जीतें!",
    "🎬 Demo Mode: Click \"Analyze URL\" to see detection" to "🎬 डेमो मोड: पता लगाने के लिए \"यूआरएल का विश्लेषण करें\" पर क्लिक करें",
    "🎮 Craft a sneaky phishing URL..." to "🎮एक गुप्त फ़िशिंग यूआरएल तैयार करें...",
    "🎮 Game Mode: Try to craft a URL that gets detected as SAFE!" to "🎮 गेम मोड: एक ऐसा यूआरएल तैयार करने का प्रयास करें जो सुरक्षित के रूप में पहचाना जाता है!",
    "🏆 Players challenged:" to "🏆 खिलाड़ियों ने चुनौती दी:",
    "🏆 You beat the bot! Score: {score}/{attempts}" to "🏆 आपने बॉट को हरा दिया! स्कोर: {score}/{attempts}",
    "💡 What would reduce this?" to "💡 इसे क्या कम करेगा?",
    "🔒 100% offline • Zero data collection • Open source (Apache 2.0)" to "🔒 100% ऑफ़लाइन • शून्य डेटा संग्रह • ओपन सोर्स (अपाचे 2.0)",
    "🔒 Zero data collection • 🚀 Same engine as Android & iOS • 🧠 Ensemble ML (25+ heuristics)" to "|🔒 शून्य डेटा संग्रह • 🚀 एंड्रॉइड और आईओएस के समान इंजन • 🧠 एन्सेम्बल एमएल (25+) अनुमान)",
    "🔗 URL shortener obfuscation" to "🔗 यूआरएल शॉर्टनर अस्पष्टता",
    "🔤 Typosquatting (paypa1 → paypal)" to "🔤 टाइपोस्क्वाटिंग (पेपा1 → पेपैल)",
    "🛡️ Mehr Guard Analysis" to "🛡️ [[ब्रांड]] विश्लेषण",
    "🛡️ Mehr Guard — Kotlin Multiplatform QRishing Detector" to "🛡️ [[ब्रांड]] - कोटलिन मल्टीप्लेटफॉर्म QRishing डिटेक्टर",
    "🤖 Bot wins! Phishing detected. Score: {score}/{attempts}" to "🤖बॉट जीत गया! फ़िशिंग का पता चला. स्कोर: {score}/{attempts}",
    "🧑‍⚖️ Demo: Forced MALICIOUS result" to "🧑‍⚖️ डेमो: जबरन दुर्भावनापूर्ण परिणाम",
    "🧑‍⚖️ Judge Mode ON - All URLs will show MALICIOUS" to "🧑‍⚖️ जज मोड चालू - सभी URL MALICIOUS दिखाएंगे",
    "🧑‍⚖️ Judge Mode activated - Demo history loaded!" to "🧑‍⚖️ जज मोड सक्रिय - डेमो इतिहास लोडेड!",
    "🧪 Try these examples:" to "🧪इन उदाहरणों को आज़माएं:",
    "Added {date}" to "{date} को जोड़ा गया",
    "Analyzing..." to "विश्लेषण हो रहा है...",
    "Camera N/A" to "कैमरा उपलब्ध नहीं",
    "Error analyzing URL: {error}" to "URL का विश्लेषण करते समय त्रुटि: {error}",
    "Challenge Mehr Guard's offline AI engine. Can you spot phishing URLs faster than the bot?" to "Mehr Guard के ऑफ़लाइन AI इंजन को चुनौती दें। क्या आप बॉट से तेज़ फ़िशिंग URL पहचान सकते हैं?",
    "Paste URL to analyze (e.g., https://example.com)" to "विश्लेषण के लिए URL पेस्ट करें (उदा., https://example.com)",
    "Mehr Guard Active Scanner - Real-time QR code scanning with AI-powered phishing detection." to "Mehr Guard एक्टिव स्कैनर — AI आधारित फ़िशिंग डिटेक्शन के साथ रियल‑टाइम QR कोड स्कैनिंग।",
    "Mehr Guard Dashboard - Enterprise offline QR code security with explainable threat detection." to "Mehr Guard डैशबोर्ड — उद्यम-स्तरीय ऑफ़लाइन QR कोड सुरक्षा और व्याख्येय खतरा पहचान।",
    "Mehr Guard Privacy Settings - 100% offline protection with zero cloud telemetry." to "Mehr Guard गोपनीयता सेटिंग्स — 100% ऑफ़लाइन सुरक्षा, बिना क्लाउड टेलीमेट्री के।",
    "Mehr Guard Report Export - Generate and download threat analysis reports in PDF or JSON format." to "Mehr Guard रिपोर्ट निर्यात — PDF या JSON फॉर्मेट में खतरा विश्लेषण रिपोर्ट बनाएं और डाउनलोड करें।",
    "Mehr Guard Threat Analysis - Detailed scan result showing attack breakdown and security recommendations." to "Mehr Guard खतरा विश्लेषण — हमले का विवरण और सुरक्षा सिफारिशें दिखाने वाला विस्तृत स्कैन परिणाम।",
    "Mehr Guard Trust Centre - Manage privacy controls, detection sensitivity, and security lists." to "Mehr Guard ट्रस्ट सेंटर — गोपनीयता नियंत्रण, पहचान संवेदनशीलता और सुरक्षा सूचियों का प्रबंधन।",
    "Mehr Guard Web - AI-powered phishing detection running entirely in your browser. Scan and analyze URLs for security threats." to "Mehr Guard Web — आपके ब्राउज़र में पूरी तरह चलने वाला AI‑आधारित फ़िशिंग डिटेक्शन। सुरक्षा खतरों के लिए URL स्कैन और विश्लेषण करें।",
    "Mehr Guard scan results - AI-powered phishing detection with detailed security analysis." to "Mehr Guard स्कैन परिणाम — विस्तृत सुरक्षा विश्लेषण के साथ AI आधारित फ़िशिंग डिटेक्शन।",
    "why" to "क्यों",
    "heuristics" to "ह्यूरिस्टिक्स",
    "redirects" to "रीडायरेक्ट",
    "ssl_issuer" to "ssl_जारीकर्ता",
    "subdomain_chaining" to "उपडोमेन_श्रृंखला",
    "suspicious_tld" to "संदिग्ध_tld",
    "threat_type" to "खतरा_प्रकार",
)
